var zt = Object.defineProperty, Kt = Object.defineProperties;
var Wt = Object.getOwnPropertyDescriptors;
var Ue = Object.getOwnPropertySymbols;
var Xt = Object.prototype.hasOwnProperty, Yt = Object.prototype.propertyIsEnumerable;
var je = (e, t, r) => t in e ? zt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, fe = (e, t) => {
  for (var r in t || (t = {}))
    Xt.call(t, r) && je(e, r, t[r]);
  if (Ue)
    for (var r of Ue(t))
      Yt.call(t, r) && je(e, r, t[r]);
  return e;
}, me = (e, t) => Kt(e, Wt(t));
var ye = (e, t, r) => {
  if (!t.has(e))
    throw TypeError("Cannot " + r);
};
var x = (e, t, r) => (ye(e, t, "read from private field"), r ? r.call(e) : t.get(e)), H = (e, t, r) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, r);
}, G = (e, t, r, n) => (ye(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r);
var te = (e, t, r) => (ye(e, t, "access private method"), r);
var Se = function(e, t) {
  return Se = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var a in n)
      Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
  }, Se(e, t);
};
function I(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Se(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var _ = function() {
  return _ = Object.assign || function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, _.apply(this, arguments);
};
function Jt(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
}
function M(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, a = t.length, i; n < a; n++)
      (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var g;
(function(e) {
  e[e.EXPECT_ARGUMENT_CLOSING_BRACE = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE", e[e.EMPTY_ARGUMENT = 2] = "EMPTY_ARGUMENT", e[e.MALFORMED_ARGUMENT = 3] = "MALFORMED_ARGUMENT", e[e.EXPECT_ARGUMENT_TYPE = 4] = "EXPECT_ARGUMENT_TYPE", e[e.INVALID_ARGUMENT_TYPE = 5] = "INVALID_ARGUMENT_TYPE", e[e.EXPECT_ARGUMENT_STYLE = 6] = "EXPECT_ARGUMENT_STYLE", e[e.INVALID_NUMBER_SKELETON = 7] = "INVALID_NUMBER_SKELETON", e[e.INVALID_DATE_TIME_SKELETON = 8] = "INVALID_DATE_TIME_SKELETON", e[e.EXPECT_NUMBER_SKELETON = 9] = "EXPECT_NUMBER_SKELETON", e[e.EXPECT_DATE_TIME_SKELETON = 10] = "EXPECT_DATE_TIME_SKELETON", e[e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE", e[e.EXPECT_SELECT_ARGUMENT_OPTIONS = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS", e[e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT", e[e.INVALID_PLURAL_ARGUMENT_SELECTOR = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR", e[e.MISSING_OTHER_CLAUSE = 22] = "MISSING_OTHER_CLAUSE", e[e.INVALID_TAG = 23] = "INVALID_TAG", e[e.INVALID_TAG_NAME = 25] = "INVALID_TAG_NAME", e[e.UNMATCHED_CLOSING_TAG = 26] = "UNMATCHED_CLOSING_TAG", e[e.UNCLOSED_TAG = 27] = "UNCLOSED_TAG";
})(g || (g = {}));
var E;
(function(e) {
  e[e.literal = 0] = "literal", e[e.argument = 1] = "argument", e[e.number = 2] = "number", e[e.date = 3] = "date", e[e.time = 4] = "time", e[e.select = 5] = "select", e[e.plural = 6] = "plural", e[e.pound = 7] = "pound", e[e.tag = 8] = "tag";
})(E || (E = {}));
var q;
(function(e) {
  e[e.number = 0] = "number", e[e.dateTime = 1] = "dateTime";
})(q || (q = {}));
function $e(e) {
  return e.type === E.literal;
}
function Qt(e) {
  return e.type === E.argument;
}
function lt(e) {
  return e.type === E.number;
}
function _t(e) {
  return e.type === E.date;
}
function ft(e) {
  return e.type === E.time;
}
function mt(e) {
  return e.type === E.select;
}
function yt(e) {
  return e.type === E.plural;
}
function er(e) {
  return e.type === E.pound;
}
function gt(e) {
  return e.type === E.tag;
}
function vt(e) {
  return !!(e && typeof e == "object" && e.type === q.number);
}
function xe(e) {
  return !!(e && typeof e == "object" && e.type === q.dateTime);
}
var pt = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/, tr = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function rr(e) {
  var t = {};
  return e.replace(tr, function(r) {
    var n = r.length;
    switch (r[0]) {
      case "G":
        t.era = n === 4 ? "long" : n === 5 ? "narrow" : "short";
        break;
      case "y":
        t.year = n === 2 ? "2-digit" : "numeric";
        break;
      case "Y":
      case "u":
      case "U":
      case "r":
        throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
      case "q":
      case "Q":
        throw new RangeError("`q/Q` (quarter) patterns are not supported");
      case "M":
      case "L":
        t.month = ["numeric", "2-digit", "short", "long", "narrow"][n - 1];
        break;
      case "w":
      case "W":
        throw new RangeError("`w/W` (week) patterns are not supported");
      case "d":
        t.day = ["numeric", "2-digit"][n - 1];
        break;
      case "D":
      case "F":
      case "g":
        throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
      case "E":
        t.weekday = n === 4 ? "long" : n === 5 ? "narrow" : "short";
        break;
      case "e":
        if (n < 4)
          throw new RangeError("`e..eee` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][n - 4];
        break;
      case "c":
        if (n < 4)
          throw new RangeError("`c..ccc` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][n - 4];
        break;
      case "a":
        t.hour12 = !0;
        break;
      case "b":
      case "B":
        throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
      case "h":
        t.hourCycle = "h12", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "H":
        t.hourCycle = "h23", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "K":
        t.hourCycle = "h11", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "k":
        t.hourCycle = "h24", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "j":
      case "J":
      case "C":
        throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
      case "m":
        t.minute = ["numeric", "2-digit"][n - 1];
        break;
      case "s":
        t.second = ["numeric", "2-digit"][n - 1];
        break;
      case "S":
      case "A":
        throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
      case "z":
        t.timeZoneName = n < 4 ? "short" : "long";
        break;
      case "Z":
      case "O":
      case "v":
      case "V":
      case "X":
      case "x":
        throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
    }
    return "";
  }), t;
}
var nr = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
function ar(e) {
  if (e.length === 0)
    throw new Error("Number skeleton cannot be empty");
  for (var t = e.split(nr).filter(function(l) {
    return l.length > 0;
  }), r = [], n = 0, a = t; n < a.length; n++) {
    var i = a[n], s = i.split("/");
    if (s.length === 0)
      throw new Error("Invalid number skeleton");
    for (var o = s[0], u = s.slice(1), c = 0, d = u; c < d.length; c++) {
      var h = d[c];
      if (h.length === 0)
        throw new Error("Invalid number skeleton");
    }
    r.push({ stem: o, options: u });
  }
  return r;
}
function ir(e) {
  return e.replace(/^(.*?)-/, "");
}
var Ve = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g, bt = /^(@+)?(\+|#+)?[rs]?$/g, sr = /(\*)(0+)|(#+)(0+)|(0+)/g, Et = /^(0+)$/;
function ke(e) {
  var t = {};
  return e[e.length - 1] === "r" ? t.roundingPriority = "morePrecision" : e[e.length - 1] === "s" && (t.roundingPriority = "lessPrecision"), e.replace(bt, function(r, n, a) {
    return typeof a != "string" ? (t.minimumSignificantDigits = n.length, t.maximumSignificantDigits = n.length) : a === "+" ? t.minimumSignificantDigits = n.length : n[0] === "#" ? t.maximumSignificantDigits = n.length : (t.minimumSignificantDigits = n.length, t.maximumSignificantDigits = n.length + (typeof a == "string" ? a.length : 0)), "";
  }), t;
}
function wt(e) {
  switch (e) {
    case "sign-auto":
      return {
        signDisplay: "auto"
      };
    case "sign-accounting":
    case "()":
      return {
        currencySign: "accounting"
      };
    case "sign-always":
    case "+!":
      return {
        signDisplay: "always"
      };
    case "sign-accounting-always":
    case "()!":
      return {
        signDisplay: "always",
        currencySign: "accounting"
      };
    case "sign-except-zero":
    case "+?":
      return {
        signDisplay: "exceptZero"
      };
    case "sign-accounting-except-zero":
    case "()?":
      return {
        signDisplay: "exceptZero",
        currencySign: "accounting"
      };
    case "sign-never":
    case "+_":
      return {
        signDisplay: "never"
      };
  }
}
function or(e) {
  var t;
  if (e[0] === "E" && e[1] === "E" ? (t = {
    notation: "engineering"
  }, e = e.slice(2)) : e[0] === "E" && (t = {
    notation: "scientific"
  }, e = e.slice(1)), t) {
    var r = e.slice(0, 2);
    if (r === "+!" ? (t.signDisplay = "always", e = e.slice(2)) : r === "+?" && (t.signDisplay = "exceptZero", e = e.slice(2)), !Et.test(e))
      throw new Error("Malformed concise eng/scientific notation");
    t.minimumIntegerDigits = e.length;
  }
  return t;
}
function Ze(e) {
  var t = {}, r = wt(e);
  return r || t;
}
function ur(e) {
  for (var t = {}, r = 0, n = e; r < n.length; r++) {
    var a = n[r];
    switch (a.stem) {
      case "percent":
      case "%":
        t.style = "percent";
        continue;
      case "%x100":
        t.style = "percent", t.scale = 100;
        continue;
      case "currency":
        t.style = "currency", t.currency = a.options[0];
        continue;
      case "group-off":
      case ",_":
        t.useGrouping = !1;
        continue;
      case "precision-integer":
      case ".":
        t.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        t.style = "unit", t.unit = ir(a.options[0]);
        continue;
      case "compact-short":
      case "K":
        t.notation = "compact", t.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        t.notation = "compact", t.compactDisplay = "long";
        continue;
      case "scientific":
        t = _(_(_({}, t), { notation: "scientific" }), a.options.reduce(function(u, c) {
          return _(_({}, u), Ze(c));
        }, {}));
        continue;
      case "engineering":
        t = _(_(_({}, t), { notation: "engineering" }), a.options.reduce(function(u, c) {
          return _(_({}, u), Ze(c));
        }, {}));
        continue;
      case "notation-simple":
        t.notation = "standard";
        continue;
      case "unit-width-narrow":
        t.currencyDisplay = "narrowSymbol", t.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        t.currencyDisplay = "code", t.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        t.currencyDisplay = "name", t.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        t.currencyDisplay = "symbol";
        continue;
      case "scale":
        t.scale = parseFloat(a.options[0]);
        continue;
      case "rounding-mode-floor":
        t.roundingMode = "floor";
        continue;
      case "rounding-mode-ceiling":
        t.roundingMode = "ceil";
        continue;
      case "rounding-mode-down":
        t.roundingMode = "trunc";
        continue;
      case "rounding-mode-up":
        t.roundingMode = "expand";
        continue;
      case "rounding-mode-half-even":
        t.roundingMode = "halfEven";
        continue;
      case "rounding-mode-half-down":
        t.roundingMode = "halfTrunc";
        continue;
      case "rounding-mode-half-up":
        t.roundingMode = "halfExpand";
        continue;
      case "integer-width":
        if (a.options.length > 1)
          throw new RangeError("integer-width stems only accept a single optional option");
        a.options[0].replace(sr, function(u, c, d, h, l, f) {
          if (c)
            t.minimumIntegerDigits = d.length;
          else {
            if (h && l)
              throw new Error("We currently do not support maximum integer digits");
            if (f)
              throw new Error("We currently do not support exact integer digits");
          }
          return "";
        });
        continue;
    }
    if (Et.test(a.stem)) {
      t.minimumIntegerDigits = a.stem.length;
      continue;
    }
    if (Ve.test(a.stem)) {
      if (a.options.length > 1)
        throw new RangeError("Fraction-precision stems only accept a single optional option");
      a.stem.replace(Ve, function(u, c, d, h, l, f) {
        return d === "*" ? t.minimumFractionDigits = c.length : h && h[0] === "#" ? t.maximumFractionDigits = h.length : l && f ? (t.minimumFractionDigits = l.length, t.maximumFractionDigits = l.length + f.length) : (t.minimumFractionDigits = c.length, t.maximumFractionDigits = c.length), "";
      });
      var i = a.options[0];
      i === "w" ? t = _(_({}, t), { trailingZeroDisplay: "stripIfInteger" }) : i && (t = _(_({}, t), ke(i)));
      continue;
    }
    if (bt.test(a.stem)) {
      t = _(_({}, t), ke(a.stem));
      continue;
    }
    var s = wt(a.stem);
    s && (t = _(_({}, t), s));
    var o = or(a.stem);
    o && (t = _(_({}, t), o));
  }
  return t;
}
var re = {
  "001": [
    "H",
    "h"
  ],
  AC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AD: [
    "H",
    "hB"
  ],
  AE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  AF: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  AG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AL: [
    "h",
    "H",
    "hB"
  ],
  AM: [
    "H",
    "hB"
  ],
  AO: [
    "H",
    "hB"
  ],
  AR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  AS: [
    "h",
    "H"
  ],
  AT: [
    "H",
    "hB"
  ],
  AU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AW: [
    "H",
    "hB"
  ],
  AX: [
    "H"
  ],
  AZ: [
    "H",
    "hB",
    "h"
  ],
  BA: [
    "H",
    "hB",
    "h"
  ],
  BB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BD: [
    "h",
    "hB",
    "H"
  ],
  BE: [
    "H",
    "hB"
  ],
  BF: [
    "H",
    "hB"
  ],
  BG: [
    "H",
    "hB",
    "h"
  ],
  BH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  BI: [
    "H",
    "h"
  ],
  BJ: [
    "H",
    "hB"
  ],
  BL: [
    "H",
    "hB"
  ],
  BM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BN: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  BO: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  BQ: [
    "H"
  ],
  BR: [
    "H",
    "hB"
  ],
  BS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BT: [
    "h",
    "H"
  ],
  BW: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  BY: [
    "H",
    "h"
  ],
  BZ: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CA: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  CC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CD: [
    "hB",
    "H"
  ],
  CF: [
    "H",
    "h",
    "hB"
  ],
  CG: [
    "H",
    "hB"
  ],
  CH: [
    "H",
    "hB",
    "h"
  ],
  CI: [
    "H",
    "hB"
  ],
  CK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CL: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CM: [
    "H",
    "h",
    "hB"
  ],
  CN: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  CO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CP: [
    "H"
  ],
  CR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CU: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CV: [
    "H",
    "hB"
  ],
  CW: [
    "H",
    "hB"
  ],
  CX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CY: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  CZ: [
    "H"
  ],
  DE: [
    "H",
    "hB"
  ],
  DG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  DJ: [
    "h",
    "H"
  ],
  DK: [
    "H"
  ],
  DM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  DO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  DZ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  EC: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  EE: [
    "H",
    "hB"
  ],
  EG: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  ER: [
    "h",
    "H"
  ],
  ES: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  ET: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  FI: [
    "H"
  ],
  FJ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  FM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FO: [
    "H",
    "h"
  ],
  FR: [
    "H",
    "hB"
  ],
  GA: [
    "H",
    "hB"
  ],
  GB: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GD: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GE: [
    "H",
    "hB",
    "h"
  ],
  GF: [
    "H",
    "hB"
  ],
  GG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GH: [
    "h",
    "H"
  ],
  GI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GL: [
    "H",
    "h"
  ],
  GM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GN: [
    "H",
    "hB"
  ],
  GP: [
    "H",
    "hB"
  ],
  GQ: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  GR: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  GT: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  GU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GW: [
    "H",
    "hB"
  ],
  GY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  HK: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  HN: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  HR: [
    "H",
    "hB"
  ],
  HU: [
    "H",
    "h"
  ],
  IC: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  ID: [
    "H"
  ],
  IE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IL: [
    "H",
    "hB"
  ],
  IM: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IN: [
    "h",
    "H"
  ],
  IO: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IQ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  IR: [
    "hB",
    "H"
  ],
  IS: [
    "H"
  ],
  IT: [
    "H",
    "hB"
  ],
  JE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  JM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  JO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  JP: [
    "H",
    "K",
    "h"
  ],
  KE: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  KG: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KH: [
    "hB",
    "h",
    "H",
    "hb"
  ],
  KI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KM: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KN: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KP: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KW: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  KY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KZ: [
    "H",
    "hB"
  ],
  LA: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  LB: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  LC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LI: [
    "H",
    "hB",
    "h"
  ],
  LK: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  LR: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LS: [
    "h",
    "H"
  ],
  LT: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  LU: [
    "H",
    "h",
    "hB"
  ],
  LV: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  LY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MC: [
    "H",
    "hB"
  ],
  MD: [
    "H",
    "hB"
  ],
  ME: [
    "H",
    "hB",
    "h"
  ],
  MF: [
    "H",
    "hB"
  ],
  MG: [
    "H",
    "h"
  ],
  MH: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ML: [
    "H"
  ],
  MM: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  MN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MP: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MQ: [
    "H",
    "hB"
  ],
  MR: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MS: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MT: [
    "H",
    "h"
  ],
  MU: [
    "H",
    "h"
  ],
  MV: [
    "H",
    "h"
  ],
  MW: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MX: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MY: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  MZ: [
    "H",
    "hB"
  ],
  NA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  NC: [
    "H",
    "hB"
  ],
  NE: [
    "H"
  ],
  NF: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NI: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  NL: [
    "H",
    "hB"
  ],
  NO: [
    "H",
    "h"
  ],
  NP: [
    "H",
    "h",
    "hB"
  ],
  NR: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NU: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  OM: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PE: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  PF: [
    "H",
    "h",
    "hB"
  ],
  PG: [
    "h",
    "H"
  ],
  PH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PK: [
    "h",
    "hB",
    "H"
  ],
  PL: [
    "H",
    "h"
  ],
  PM: [
    "H",
    "hB"
  ],
  PN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  PR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PS: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PT: [
    "H",
    "hB"
  ],
  PW: [
    "h",
    "H"
  ],
  PY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  QA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  RE: [
    "H",
    "hB"
  ],
  RO: [
    "H",
    "hB"
  ],
  RS: [
    "H",
    "hB",
    "h"
  ],
  RU: [
    "H"
  ],
  RW: [
    "H",
    "h"
  ],
  SA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SC: [
    "H",
    "h",
    "hB"
  ],
  SD: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SE: [
    "H"
  ],
  SG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SH: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SI: [
    "H",
    "hB"
  ],
  SJ: [
    "H"
  ],
  SK: [
    "H"
  ],
  SL: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SM: [
    "H",
    "h",
    "hB"
  ],
  SN: [
    "H",
    "h",
    "hB"
  ],
  SO: [
    "h",
    "H"
  ],
  SR: [
    "H",
    "hB"
  ],
  SS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ST: [
    "H",
    "hB"
  ],
  SV: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  SX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  TC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TD: [
    "h",
    "H",
    "hB"
  ],
  TF: [
    "H",
    "h",
    "hB"
  ],
  TG: [
    "H",
    "hB"
  ],
  TH: [
    "H",
    "h"
  ],
  TJ: [
    "H",
    "h"
  ],
  TL: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  TM: [
    "H",
    "h"
  ],
  TN: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  TO: [
    "h",
    "H"
  ],
  TR: [
    "H",
    "hB"
  ],
  TT: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TW: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  TZ: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UA: [
    "H",
    "hB",
    "h"
  ],
  UG: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  US: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  UY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  UZ: [
    "H",
    "hB",
    "h"
  ],
  VA: [
    "H",
    "h",
    "hB"
  ],
  VC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VE: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  VG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VN: [
    "H",
    "h"
  ],
  VU: [
    "h",
    "H"
  ],
  WF: [
    "H",
    "hB"
  ],
  WS: [
    "h",
    "H"
  ],
  XK: [
    "H",
    "hB",
    "h"
  ],
  YE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  YT: [
    "H",
    "hB"
  ],
  ZA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ZM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ZW: [
    "H",
    "h"
  ],
  "af-ZA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "ar-001": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "ca-ES": [
    "H",
    "h",
    "hB"
  ],
  "en-001": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "es-BO": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-BR": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-EC": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-ES": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-GQ": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-PE": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "fr-CA": [
    "H",
    "h",
    "hB"
  ],
  "gl-ES": [
    "H",
    "h",
    "hB"
  ],
  "gu-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "hi-IN": [
    "hB",
    "h",
    "H"
  ],
  "it-CH": [
    "H",
    "h",
    "hB"
  ],
  "it-IT": [
    "H",
    "h",
    "hB"
  ],
  "kn-IN": [
    "hB",
    "h",
    "H"
  ],
  "ml-IN": [
    "hB",
    "h",
    "H"
  ],
  "mr-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "pa-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "ta-IN": [
    "hB",
    "h",
    "hb",
    "H"
  ],
  "te-IN": [
    "hB",
    "h",
    "H"
  ],
  "zu-ZA": [
    "H",
    "hB",
    "hb",
    "h"
  ]
};
function dr(e, t) {
  for (var r = "", n = 0; n < e.length; n++) {
    var a = e.charAt(n);
    if (a === "j") {
      for (var i = 0; n + 1 < e.length && e.charAt(n + 1) === a; )
        i++, n++;
      var s = 1 + (i & 1), o = i < 2 ? 1 : 3 + (i >> 1), u = "a", c = cr(t);
      for ((c == "H" || c == "k") && (o = 0); o-- > 0; )
        r += u;
      for (; s-- > 0; )
        r = c + r;
    } else
      a === "J" ? r += "H" : r += a;
  }
  return r;
}
function cr(e) {
  var t = e.hourCycle;
  if (t === void 0 && // @ts-ignore hourCycle(s) is not identified yet
  e.hourCycles && // @ts-ignore
  e.hourCycles.length && (t = e.hourCycles[0]), t)
    switch (t) {
      case "h24":
        return "k";
      case "h23":
        return "H";
      case "h12":
        return "h";
      case "h11":
        return "K";
      default:
        throw new Error("Invalid hourCycle");
    }
  var r = e.language, n;
  r !== "root" && (n = e.maximize().region);
  var a = re[n || ""] || re[r || ""] || re["".concat(r, "-001")] || re["001"];
  return a[0];
}
var ge, hr = new RegExp("^".concat(pt.source, "*")), lr = new RegExp("".concat(pt.source, "*$"));
function p(e, t) {
  return { start: e, end: t };
}
var _r = !!String.prototype.startsWith && "_a".startsWith("a", 1), fr = !!String.fromCodePoint, mr = !!Object.fromEntries, yr = !!String.prototype.codePointAt, gr = !!String.prototype.trimStart, vr = !!String.prototype.trimEnd, pr = !!Number.isSafeInteger, br = pr ? Number.isSafeInteger : function(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e && Math.abs(e) <= 9007199254740991;
}, Me = !0;
try {
  var Er = St("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  Me = ((ge = Er.exec("a")) === null || ge === void 0 ? void 0 : ge[0]) === "a";
} catch (e) {
  Me = !1;
}
var qe = _r ? (
  // Native
  function(t, r, n) {
    return t.startsWith(r, n);
  }
) : (
  // For IE11
  function(t, r, n) {
    return t.slice(n, n + r.length) === r;
  }
), Ae = fr ? String.fromCodePoint : (
  // IE11
  function() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    for (var n = "", a = t.length, i = 0, s; a > i; ) {
      if (s = t[i++], s > 1114111)
        throw RangeError(s + " is not a valid code point");
      n += s < 65536 ? String.fromCharCode(s) : String.fromCharCode(((s -= 65536) >> 10) + 55296, s % 1024 + 56320);
    }
    return n;
  }
), ze = (
  // native
  mr ? Object.fromEntries : (
    // Ponyfill
    function(t) {
      for (var r = {}, n = 0, a = t; n < a.length; n++) {
        var i = a[n], s = i[0], o = i[1];
        r[s] = o;
      }
      return r;
    }
  )
), Tt = yr ? (
  // Native
  function(t, r) {
    return t.codePointAt(r);
  }
) : (
  // IE 11
  function(t, r) {
    var n = t.length;
    if (!(r < 0 || r >= n)) {
      var a = t.charCodeAt(r), i;
      return a < 55296 || a > 56319 || r + 1 === n || (i = t.charCodeAt(r + 1)) < 56320 || i > 57343 ? a : (a - 55296 << 10) + (i - 56320) + 65536;
    }
  }
), wr = gr ? (
  // Native
  function(t) {
    return t.trimStart();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(hr, "");
  }
), Tr = vr ? (
  // Native
  function(t) {
    return t.trimEnd();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(lr, "");
  }
);
function St(e, t) {
  return new RegExp(e, t);
}
var Ie;
if (Me) {
  var Ke = St("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  Ie = function(t, r) {
    var n;
    Ke.lastIndex = r;
    var a = Ke.exec(t);
    return (n = a[1]) !== null && n !== void 0 ? n : "";
  };
} else
  Ie = function(t, r) {
    for (var n = []; ; ) {
      var a = Tt(t, r);
      if (a === void 0 || xt(a) || Ar(a))
        break;
      n.push(a), r += a >= 65536 ? 2 : 1;
    }
    return Ae.apply(void 0, n);
  };
var Sr = (
  /** @class */
  function() {
    function e(t, r) {
      r === void 0 && (r = {}), this.message = t, this.position = { offset: 0, line: 1, column: 1 }, this.ignoreTag = !!r.ignoreTag, this.locale = r.locale, this.requiresOtherClause = !!r.requiresOtherClause, this.shouldParseSkeletons = !!r.shouldParseSkeletons;
    }
    return e.prototype.parse = function() {
      if (this.offset() !== 0)
        throw Error("parser can only be used once");
      return this.parseMessage(0, "", !1);
    }, e.prototype.parseMessage = function(t, r, n) {
      for (var a = []; !this.isEOF(); ) {
        var i = this.char();
        if (i === 123) {
          var s = this.parseArgument(t, n);
          if (s.err)
            return s;
          a.push(s.val);
        } else {
          if (i === 125 && t > 0)
            break;
          if (i === 35 && (r === "plural" || r === "selectordinal")) {
            var o = this.clonePosition();
            this.bump(), a.push({
              type: E.pound,
              location: p(o, this.clonePosition())
            });
          } else if (i === 60 && !this.ignoreTag && this.peek() === 47) {
            if (n)
              break;
            return this.error(g.UNMATCHED_CLOSING_TAG, p(this.clonePosition(), this.clonePosition()));
          } else if (i === 60 && !this.ignoreTag && He(this.peek() || 0)) {
            var s = this.parseTag(t, r);
            if (s.err)
              return s;
            a.push(s.val);
          } else {
            var s = this.parseLiteral(t, r);
            if (s.err)
              return s;
            a.push(s.val);
          }
        }
      }
      return { val: a, err: null };
    }, e.prototype.parseTag = function(t, r) {
      var n = this.clonePosition();
      this.bump();
      var a = this.parseTagName();
      if (this.bumpSpace(), this.bumpIf("/>"))
        return {
          val: {
            type: E.literal,
            value: "<".concat(a, "/>"),
            location: p(n, this.clonePosition())
          },
          err: null
        };
      if (this.bumpIf(">")) {
        var i = this.parseMessage(t + 1, r, !0);
        if (i.err)
          return i;
        var s = i.val, o = this.clonePosition();
        if (this.bumpIf("</")) {
          if (this.isEOF() || !He(this.char()))
            return this.error(g.INVALID_TAG, p(o, this.clonePosition()));
          var u = this.clonePosition(), c = this.parseTagName();
          return a !== c ? this.error(g.UNMATCHED_CLOSING_TAG, p(u, this.clonePosition())) : (this.bumpSpace(), this.bumpIf(">") ? {
            val: {
              type: E.tag,
              value: a,
              children: s,
              location: p(n, this.clonePosition())
            },
            err: null
          } : this.error(g.INVALID_TAG, p(o, this.clonePosition())));
        } else
          return this.error(g.UNCLOSED_TAG, p(n, this.clonePosition()));
      } else
        return this.error(g.INVALID_TAG, p(n, this.clonePosition()));
    }, e.prototype.parseTagName = function() {
      var t = this.offset();
      for (this.bump(); !this.isEOF() && Mr(this.char()); )
        this.bump();
      return this.message.slice(t, this.offset());
    }, e.prototype.parseLiteral = function(t, r) {
      for (var n = this.clonePosition(), a = ""; ; ) {
        var i = this.tryParseQuote(r);
        if (i) {
          a += i;
          continue;
        }
        var s = this.tryParseUnquoted(t, r);
        if (s) {
          a += s;
          continue;
        }
        var o = this.tryParseLeftAngleBracket();
        if (o) {
          a += o;
          continue;
        }
        break;
      }
      var u = p(n, this.clonePosition());
      return {
        val: { type: E.literal, value: a, location: u },
        err: null
      };
    }, e.prototype.tryParseLeftAngleBracket = function() {
      return !this.isEOF() && this.char() === 60 && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
      !xr(this.peek() || 0)) ? (this.bump(), "<") : null;
    }, e.prototype.tryParseQuote = function(t) {
      if (this.isEOF() || this.char() !== 39)
        return null;
      switch (this.peek()) {
        case 39:
          return this.bump(), this.bump(), "'";
        case 123:
        case 60:
        case 62:
        case 125:
          break;
        case 35:
          if (t === "plural" || t === "selectordinal")
            break;
          return null;
        default:
          return null;
      }
      this.bump();
      var r = [this.char()];
      for (this.bump(); !this.isEOF(); ) {
        var n = this.char();
        if (n === 39)
          if (this.peek() === 39)
            r.push(39), this.bump();
          else {
            this.bump();
            break;
          }
        else
          r.push(n);
        this.bump();
      }
      return Ae.apply(void 0, r);
    }, e.prototype.tryParseUnquoted = function(t, r) {
      if (this.isEOF())
        return null;
      var n = this.char();
      return n === 60 || n === 123 || n === 35 && (r === "plural" || r === "selectordinal") || n === 125 && t > 0 ? null : (this.bump(), Ae(n));
    }, e.prototype.parseArgument = function(t, r) {
      var n = this.clonePosition();
      if (this.bump(), this.bumpSpace(), this.isEOF())
        return this.error(g.EXPECT_ARGUMENT_CLOSING_BRACE, p(n, this.clonePosition()));
      if (this.char() === 125)
        return this.bump(), this.error(g.EMPTY_ARGUMENT, p(n, this.clonePosition()));
      var a = this.parseIdentifierIfPossible().value;
      if (!a)
        return this.error(g.MALFORMED_ARGUMENT, p(n, this.clonePosition()));
      if (this.bumpSpace(), this.isEOF())
        return this.error(g.EXPECT_ARGUMENT_CLOSING_BRACE, p(n, this.clonePosition()));
      switch (this.char()) {
        case 125:
          return this.bump(), {
            val: {
              type: E.argument,
              // value does not include the opening and closing braces.
              value: a,
              location: p(n, this.clonePosition())
            },
            err: null
          };
        case 44:
          return this.bump(), this.bumpSpace(), this.isEOF() ? this.error(g.EXPECT_ARGUMENT_CLOSING_BRACE, p(n, this.clonePosition())) : this.parseArgumentOptions(t, r, a, n);
        default:
          return this.error(g.MALFORMED_ARGUMENT, p(n, this.clonePosition()));
      }
    }, e.prototype.parseIdentifierIfPossible = function() {
      var t = this.clonePosition(), r = this.offset(), n = Ie(this.message, r), a = r + n.length;
      this.bumpTo(a);
      var i = this.clonePosition(), s = p(t, i);
      return { value: n, location: s };
    }, e.prototype.parseArgumentOptions = function(t, r, n, a) {
      var i, s = this.clonePosition(), o = this.parseIdentifierIfPossible().value, u = this.clonePosition();
      switch (o) {
        case "":
          return this.error(g.EXPECT_ARGUMENT_TYPE, p(s, u));
        case "number":
        case "date":
        case "time": {
          this.bumpSpace();
          var c = null;
          if (this.bumpIf(",")) {
            this.bumpSpace();
            var d = this.clonePosition(), h = this.parseSimpleArgStyleIfPossible();
            if (h.err)
              return h;
            var l = Tr(h.val);
            if (l.length === 0)
              return this.error(g.EXPECT_ARGUMENT_STYLE, p(this.clonePosition(), this.clonePosition()));
            var f = p(d, this.clonePosition());
            c = { style: l, styleLocation: f };
          }
          var v = this.tryParseArgumentClose(a);
          if (v.err)
            return v;
          var m = p(a, this.clonePosition());
          if (c && qe(c == null ? void 0 : c.style, "::", 0)) {
            var y = wr(c.style.slice(2));
            if (o === "number") {
              var h = this.parseNumberSkeletonFromString(y, c.styleLocation);
              return h.err ? h : {
                val: { type: E.number, value: n, location: m, style: h.val },
                err: null
              };
            } else {
              if (y.length === 0)
                return this.error(g.EXPECT_DATE_TIME_SKELETON, m);
              var b = y;
              this.locale && (b = dr(y, this.locale));
              var l = {
                type: q.dateTime,
                pattern: b,
                location: c.styleLocation,
                parsedOptions: this.shouldParseSkeletons ? rr(b) : {}
              }, T = o === "date" ? E.date : E.time;
              return {
                val: { type: T, value: n, location: m, style: l },
                err: null
              };
            }
          }
          return {
            val: {
              type: o === "number" ? E.number : o === "date" ? E.date : E.time,
              value: n,
              location: m,
              style: (i = c == null ? void 0 : c.style) !== null && i !== void 0 ? i : null
            },
            err: null
          };
        }
        case "plural":
        case "selectordinal":
        case "select": {
          var w = this.clonePosition();
          if (this.bumpSpace(), !this.bumpIf(","))
            return this.error(g.EXPECT_SELECT_ARGUMENT_OPTIONS, p(w, _({}, w)));
          this.bumpSpace();
          var B = this.parseIdentifierIfPossible(), P = 0;
          if (o !== "select" && B.value === "offset") {
            if (!this.bumpIf(":"))
              return this.error(g.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, p(this.clonePosition(), this.clonePosition()));
            this.bumpSpace();
            var h = this.tryParseDecimalInteger(g.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, g.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
            if (h.err)
              return h;
            this.bumpSpace(), B = this.parseIdentifierIfPossible(), P = h.val;
          }
          var $ = this.tryParsePluralOrSelectOptions(t, o, r, B);
          if ($.err)
            return $;
          var v = this.tryParseArgumentClose(a);
          if (v.err)
            return v;
          var Fe = p(a, this.clonePosition());
          return o === "select" ? {
            val: {
              type: E.select,
              value: n,
              options: ze($.val),
              location: Fe
            },
            err: null
          } : {
            val: {
              type: E.plural,
              value: n,
              options: ze($.val),
              offset: P,
              pluralType: o === "plural" ? "cardinal" : "ordinal",
              location: Fe
            },
            err: null
          };
        }
        default:
          return this.error(g.INVALID_ARGUMENT_TYPE, p(s, u));
      }
    }, e.prototype.tryParseArgumentClose = function(t) {
      return this.isEOF() || this.char() !== 125 ? this.error(g.EXPECT_ARGUMENT_CLOSING_BRACE, p(t, this.clonePosition())) : (this.bump(), { val: !0, err: null });
    }, e.prototype.parseSimpleArgStyleIfPossible = function() {
      for (var t = 0, r = this.clonePosition(); !this.isEOF(); ) {
        var n = this.char();
        switch (n) {
          case 39: {
            this.bump();
            var a = this.clonePosition();
            if (!this.bumpUntil("'"))
              return this.error(g.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, p(a, this.clonePosition()));
            this.bump();
            break;
          }
          case 123: {
            t += 1, this.bump();
            break;
          }
          case 125: {
            if (t > 0)
              t -= 1;
            else
              return {
                val: this.message.slice(r.offset, this.offset()),
                err: null
              };
            break;
          }
          default:
            this.bump();
            break;
        }
      }
      return {
        val: this.message.slice(r.offset, this.offset()),
        err: null
      };
    }, e.prototype.parseNumberSkeletonFromString = function(t, r) {
      var n = [];
      try {
        n = ar(t);
      } catch (a) {
        return this.error(g.INVALID_NUMBER_SKELETON, r);
      }
      return {
        val: {
          type: q.number,
          tokens: n,
          location: r,
          parsedOptions: this.shouldParseSkeletons ? ur(n) : {}
        },
        err: null
      };
    }, e.prototype.tryParsePluralOrSelectOptions = function(t, r, n, a) {
      for (var i, s = !1, o = [], u = /* @__PURE__ */ new Set(), c = a.value, d = a.location; ; ) {
        if (c.length === 0) {
          var h = this.clonePosition();
          if (r !== "select" && this.bumpIf("=")) {
            var l = this.tryParseDecimalInteger(g.EXPECT_PLURAL_ARGUMENT_SELECTOR, g.INVALID_PLURAL_ARGUMENT_SELECTOR);
            if (l.err)
              return l;
            d = p(h, this.clonePosition()), c = this.message.slice(h.offset, this.offset());
          } else
            break;
        }
        if (u.has(c))
          return this.error(r === "select" ? g.DUPLICATE_SELECT_ARGUMENT_SELECTOR : g.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, d);
        c === "other" && (s = !0), this.bumpSpace();
        var f = this.clonePosition();
        if (!this.bumpIf("{"))
          return this.error(r === "select" ? g.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : g.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, p(this.clonePosition(), this.clonePosition()));
        var v = this.parseMessage(t + 1, r, n);
        if (v.err)
          return v;
        var m = this.tryParseArgumentClose(f);
        if (m.err)
          return m;
        o.push([
          c,
          {
            value: v.val,
            location: p(f, this.clonePosition())
          }
        ]), u.add(c), this.bumpSpace(), i = this.parseIdentifierIfPossible(), c = i.value, d = i.location;
      }
      return o.length === 0 ? this.error(r === "select" ? g.EXPECT_SELECT_ARGUMENT_SELECTOR : g.EXPECT_PLURAL_ARGUMENT_SELECTOR, p(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !s ? this.error(g.MISSING_OTHER_CLAUSE, p(this.clonePosition(), this.clonePosition())) : { val: o, err: null };
    }, e.prototype.tryParseDecimalInteger = function(t, r) {
      var n = 1, a = this.clonePosition();
      this.bumpIf("+") || this.bumpIf("-") && (n = -1);
      for (var i = !1, s = 0; !this.isEOF(); ) {
        var o = this.char();
        if (o >= 48 && o <= 57)
          i = !0, s = s * 10 + (o - 48), this.bump();
        else
          break;
      }
      var u = p(a, this.clonePosition());
      return i ? (s *= n, br(s) ? { val: s, err: null } : this.error(r, u)) : this.error(t, u);
    }, e.prototype.offset = function() {
      return this.position.offset;
    }, e.prototype.isEOF = function() {
      return this.offset() === this.message.length;
    }, e.prototype.clonePosition = function() {
      return {
        offset: this.position.offset,
        line: this.position.line,
        column: this.position.column
      };
    }, e.prototype.char = function() {
      var t = this.position.offset;
      if (t >= this.message.length)
        throw Error("out of bound");
      var r = Tt(this.message, t);
      if (r === void 0)
        throw Error("Offset ".concat(t, " is at invalid UTF-16 code unit boundary"));
      return r;
    }, e.prototype.error = function(t, r) {
      return {
        val: null,
        err: {
          kind: t,
          message: this.message,
          location: r
        }
      };
    }, e.prototype.bump = function() {
      if (!this.isEOF()) {
        var t = this.char();
        t === 10 ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += t < 65536 ? 1 : 2);
      }
    }, e.prototype.bumpIf = function(t) {
      if (qe(this.message, t, this.offset())) {
        for (var r = 0; r < t.length; r++)
          this.bump();
        return !0;
      }
      return !1;
    }, e.prototype.bumpUntil = function(t) {
      var r = this.offset(), n = this.message.indexOf(t, r);
      return n >= 0 ? (this.bumpTo(n), !0) : (this.bumpTo(this.message.length), !1);
    }, e.prototype.bumpTo = function(t) {
      if (this.offset() > t)
        throw Error("targetOffset ".concat(t, " must be greater than or equal to the current offset ").concat(this.offset()));
      for (t = Math.min(t, this.message.length); ; ) {
        var r = this.offset();
        if (r === t)
          break;
        if (r > t)
          throw Error("targetOffset ".concat(t, " is at invalid UTF-16 code unit boundary"));
        if (this.bump(), this.isEOF())
          break;
      }
    }, e.prototype.bumpSpace = function() {
      for (; !this.isEOF() && xt(this.char()); )
        this.bump();
    }, e.prototype.peek = function() {
      if (this.isEOF())
        return null;
      var t = this.char(), r = this.offset(), n = this.message.charCodeAt(r + (t >= 65536 ? 2 : 1));
      return n != null ? n : null;
    }, e;
  }()
);
function He(e) {
  return e >= 97 && e <= 122 || e >= 65 && e <= 90;
}
function xr(e) {
  return He(e) || e === 47;
}
function Mr(e) {
  return e === 45 || e === 46 || e >= 48 && e <= 57 || e === 95 || e >= 97 && e <= 122 || e >= 65 && e <= 90 || e == 183 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8255 && e <= 8256 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
}
function xt(e) {
  return e >= 9 && e <= 13 || e === 32 || e === 133 || e >= 8206 && e <= 8207 || e === 8232 || e === 8233;
}
function Ar(e) {
  return e >= 33 && e <= 35 || e === 36 || e >= 37 && e <= 39 || e === 40 || e === 41 || e === 42 || e === 43 || e === 44 || e === 45 || e >= 46 && e <= 47 || e >= 58 && e <= 59 || e >= 60 && e <= 62 || e >= 63 && e <= 64 || e === 91 || e === 92 || e === 93 || e === 94 || e === 96 || e === 123 || e === 124 || e === 125 || e === 126 || e === 161 || e >= 162 && e <= 165 || e === 166 || e === 167 || e === 169 || e === 171 || e === 172 || e === 174 || e === 176 || e === 177 || e === 182 || e === 187 || e === 191 || e === 215 || e === 247 || e >= 8208 && e <= 8213 || e >= 8214 && e <= 8215 || e === 8216 || e === 8217 || e === 8218 || e >= 8219 && e <= 8220 || e === 8221 || e === 8222 || e === 8223 || e >= 8224 && e <= 8231 || e >= 8240 && e <= 8248 || e === 8249 || e === 8250 || e >= 8251 && e <= 8254 || e >= 8257 && e <= 8259 || e === 8260 || e === 8261 || e === 8262 || e >= 8263 && e <= 8273 || e === 8274 || e === 8275 || e >= 8277 && e <= 8286 || e >= 8592 && e <= 8596 || e >= 8597 && e <= 8601 || e >= 8602 && e <= 8603 || e >= 8604 && e <= 8607 || e === 8608 || e >= 8609 && e <= 8610 || e === 8611 || e >= 8612 && e <= 8613 || e === 8614 || e >= 8615 && e <= 8621 || e === 8622 || e >= 8623 && e <= 8653 || e >= 8654 && e <= 8655 || e >= 8656 && e <= 8657 || e === 8658 || e === 8659 || e === 8660 || e >= 8661 && e <= 8691 || e >= 8692 && e <= 8959 || e >= 8960 && e <= 8967 || e === 8968 || e === 8969 || e === 8970 || e === 8971 || e >= 8972 && e <= 8991 || e >= 8992 && e <= 8993 || e >= 8994 && e <= 9e3 || e === 9001 || e === 9002 || e >= 9003 && e <= 9083 || e === 9084 || e >= 9085 && e <= 9114 || e >= 9115 && e <= 9139 || e >= 9140 && e <= 9179 || e >= 9180 && e <= 9185 || e >= 9186 && e <= 9254 || e >= 9255 && e <= 9279 || e >= 9280 && e <= 9290 || e >= 9291 && e <= 9311 || e >= 9472 && e <= 9654 || e === 9655 || e >= 9656 && e <= 9664 || e === 9665 || e >= 9666 && e <= 9719 || e >= 9720 && e <= 9727 || e >= 9728 && e <= 9838 || e === 9839 || e >= 9840 && e <= 10087 || e === 10088 || e === 10089 || e === 10090 || e === 10091 || e === 10092 || e === 10093 || e === 10094 || e === 10095 || e === 10096 || e === 10097 || e === 10098 || e === 10099 || e === 10100 || e === 10101 || e >= 10132 && e <= 10175 || e >= 10176 && e <= 10180 || e === 10181 || e === 10182 || e >= 10183 && e <= 10213 || e === 10214 || e === 10215 || e === 10216 || e === 10217 || e === 10218 || e === 10219 || e === 10220 || e === 10221 || e === 10222 || e === 10223 || e >= 10224 && e <= 10239 || e >= 10240 && e <= 10495 || e >= 10496 && e <= 10626 || e === 10627 || e === 10628 || e === 10629 || e === 10630 || e === 10631 || e === 10632 || e === 10633 || e === 10634 || e === 10635 || e === 10636 || e === 10637 || e === 10638 || e === 10639 || e === 10640 || e === 10641 || e === 10642 || e === 10643 || e === 10644 || e === 10645 || e === 10646 || e === 10647 || e === 10648 || e >= 10649 && e <= 10711 || e === 10712 || e === 10713 || e === 10714 || e === 10715 || e >= 10716 && e <= 10747 || e === 10748 || e === 10749 || e >= 10750 && e <= 11007 || e >= 11008 && e <= 11055 || e >= 11056 && e <= 11076 || e >= 11077 && e <= 11078 || e >= 11079 && e <= 11084 || e >= 11085 && e <= 11123 || e >= 11124 && e <= 11125 || e >= 11126 && e <= 11157 || e === 11158 || e >= 11159 && e <= 11263 || e >= 11776 && e <= 11777 || e === 11778 || e === 11779 || e === 11780 || e === 11781 || e >= 11782 && e <= 11784 || e === 11785 || e === 11786 || e === 11787 || e === 11788 || e === 11789 || e >= 11790 && e <= 11798 || e === 11799 || e >= 11800 && e <= 11801 || e === 11802 || e === 11803 || e === 11804 || e === 11805 || e >= 11806 && e <= 11807 || e === 11808 || e === 11809 || e === 11810 || e === 11811 || e === 11812 || e === 11813 || e === 11814 || e === 11815 || e === 11816 || e === 11817 || e >= 11818 && e <= 11822 || e === 11823 || e >= 11824 && e <= 11833 || e >= 11834 && e <= 11835 || e >= 11836 && e <= 11839 || e === 11840 || e === 11841 || e === 11842 || e >= 11843 && e <= 11855 || e >= 11856 && e <= 11857 || e === 11858 || e >= 11859 && e <= 11903 || e >= 12289 && e <= 12291 || e === 12296 || e === 12297 || e === 12298 || e === 12299 || e === 12300 || e === 12301 || e === 12302 || e === 12303 || e === 12304 || e === 12305 || e >= 12306 && e <= 12307 || e === 12308 || e === 12309 || e === 12310 || e === 12311 || e === 12312 || e === 12313 || e === 12314 || e === 12315 || e === 12316 || e === 12317 || e >= 12318 && e <= 12319 || e === 12320 || e === 12336 || e === 64830 || e === 64831 || e >= 65093 && e <= 65094;
}
function Ne(e) {
  e.forEach(function(t) {
    if (delete t.location, mt(t) || yt(t))
      for (var r in t.options)
        delete t.options[r].location, Ne(t.options[r].value);
    else
      lt(t) && vt(t.style) || (_t(t) || ft(t)) && xe(t.style) ? delete t.style.location : gt(t) && Ne(t.children);
  });
}
function Ir(e, t) {
  t === void 0 && (t = {}), t = _({ shouldParseSkeletons: !0, requiresOtherClause: !0 }, t);
  var r = new Sr(e, t).parse();
  if (r.err) {
    var n = SyntaxError(g[r.err.kind]);
    throw n.location = r.err.location, n.originalMessage = r.err.message, n;
  }
  return t != null && t.captureLocation || Ne(r.val), r.val;
}
function N(e, t) {
  var r = t && t.cache ? t.cache : Pr, n = t && t.serializer ? t.serializer : Br, a = t && t.strategy ? t.strategy : Nr;
  return a(e, {
    cache: r,
    serializer: n
  });
}
function Hr(e) {
  return e == null || typeof e == "number" || typeof e == "boolean";
}
function Mt(e, t, r, n) {
  var a = Hr(n) ? n : r(n), i = t.get(a);
  return typeof i == "undefined" && (i = e.call(this, n), t.set(a, i)), i;
}
function At(e, t, r) {
  var n = Array.prototype.slice.call(arguments, 3), a = r(n), i = t.get(a);
  return typeof i == "undefined" && (i = e.apply(this, n), t.set(a, i)), i;
}
function Ce(e, t, r, n, a) {
  return r.bind(t, e, n, a);
}
function Nr(e, t) {
  var r = e.length === 1 ? Mt : At;
  return Ce(e, this, r, t.cache.create(), t.serializer);
}
function Cr(e, t) {
  return Ce(e, this, At, t.cache.create(), t.serializer);
}
function Lr(e, t) {
  return Ce(e, this, Mt, t.cache.create(), t.serializer);
}
var Br = function() {
  return JSON.stringify(arguments);
};
function Le() {
  this.cache = /* @__PURE__ */ Object.create(null);
}
Le.prototype.get = function(e) {
  return this.cache[e];
};
Le.prototype.set = function(e, t) {
  this.cache[e] = t;
};
var Pr = {
  create: function() {
    return new Le();
  }
}, C = {
  variadic: Cr,
  monadic: Lr
}, L;
(function(e) {
  e.MISSING_VALUE = "MISSING_VALUE", e.INVALID_VALUE = "INVALID_VALUE", e.MISSING_INTL_API = "MISSING_INTL_API";
})(L || (L = {}));
var R = (
  /** @class */
  function(e) {
    I(t, e);
    function t(r, n, a) {
      var i = e.call(this, r) || this;
      return i.code = n, i.originalMessage = a, i;
    }
    return t.prototype.toString = function() {
      return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    }, t;
  }(Error)
), We = (
  /** @class */
  function(e) {
    I(t, e);
    function t(r, n, a, i) {
      return e.call(this, 'Invalid values for "'.concat(r, '": "').concat(n, '". Options are "').concat(Object.keys(a).join('", "'), '"'), L.INVALID_VALUE, i) || this;
    }
    return t;
  }(R)
), Or = (
  /** @class */
  function(e) {
    I(t, e);
    function t(r, n, a) {
      return e.call(this, 'Value for "'.concat(r, '" must be of type ').concat(n), L.INVALID_VALUE, a) || this;
    }
    return t;
  }(R)
), Rr = (
  /** @class */
  function(e) {
    I(t, e);
    function t(r, n) {
      return e.call(this, 'The intl string context variable "'.concat(r, '" was not provided to the string "').concat(n, '"'), L.MISSING_VALUE, n) || this;
    }
    return t;
  }(R)
), S;
(function(e) {
  e[e.literal = 0] = "literal", e[e.object = 1] = "object";
})(S || (S = {}));
function Gr(e) {
  return e.length < 2 ? e : e.reduce(function(t, r) {
    var n = t[t.length - 1];
    return !n || n.type !== S.literal || r.type !== S.literal ? t.push(r) : n.value += r.value, t;
  }, []);
}
function Dr(e) {
  return typeof e == "function";
}
function se(e, t, r, n, a, i, s) {
  if (e.length === 1 && $e(e[0]))
    return [
      {
        type: S.literal,
        value: e[0].value
      }
    ];
  for (var o = [], u = 0, c = e; u < c.length; u++) {
    var d = c[u];
    if ($e(d)) {
      o.push({
        type: S.literal,
        value: d.value
      });
      continue;
    }
    if (er(d)) {
      typeof i == "number" && o.push({
        type: S.literal,
        value: r.getNumberFormat(t).format(i)
      });
      continue;
    }
    var h = d.value;
    if (!(a && h in a))
      throw new Rr(h, s);
    var l = a[h];
    if (Qt(d)) {
      (!l || typeof l == "string" || typeof l == "number") && (l = typeof l == "string" || typeof l == "number" ? String(l) : ""), o.push({
        type: typeof l == "string" ? S.literal : S.object,
        value: l
      });
      continue;
    }
    if (_t(d)) {
      var f = typeof d.style == "string" ? n.date[d.style] : xe(d.style) ? d.style.parsedOptions : void 0;
      o.push({
        type: S.literal,
        value: r.getDateTimeFormat(t, f).format(l)
      });
      continue;
    }
    if (ft(d)) {
      var f = typeof d.style == "string" ? n.time[d.style] : xe(d.style) ? d.style.parsedOptions : n.time.medium;
      o.push({
        type: S.literal,
        value: r.getDateTimeFormat(t, f).format(l)
      });
      continue;
    }
    if (lt(d)) {
      var f = typeof d.style == "string" ? n.number[d.style] : vt(d.style) ? d.style.parsedOptions : void 0;
      f && f.scale && (l = l * (f.scale || 1)), o.push({
        type: S.literal,
        value: r.getNumberFormat(t, f).format(l)
      });
      continue;
    }
    if (gt(d)) {
      var v = d.children, m = d.value, y = a[m];
      if (!Dr(y))
        throw new Or(m, "function", s);
      var b = se(v, t, r, n, a, i), T = y(b.map(function(P) {
        return P.value;
      }));
      Array.isArray(T) || (T = [T]), o.push.apply(o, T.map(function(P) {
        return {
          type: typeof P == "string" ? S.literal : S.object,
          value: P
        };
      }));
    }
    if (mt(d)) {
      var w = d.options[l] || d.options.other;
      if (!w)
        throw new We(d.value, l, Object.keys(d.options), s);
      o.push.apply(o, se(w.value, t, r, n, a));
      continue;
    }
    if (yt(d)) {
      var w = d.options["=".concat(l)];
      if (!w) {
        if (!Intl.PluralRules)
          throw new R(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, L.MISSING_INTL_API, s);
        var B = r.getPluralRules(t, { type: d.pluralType }).select(l - (d.offset || 0));
        w = d.options[B] || d.options.other;
      }
      if (!w)
        throw new We(d.value, l, Object.keys(d.options), s);
      o.push.apply(o, se(w.value, t, r, n, a, l - (d.offset || 0)));
      continue;
    }
  }
  return Gr(o);
}
function Fr(e, t) {
  return t ? _(_(_({}, e || {}), t || {}), Object.keys(e).reduce(function(r, n) {
    return r[n] = _(_({}, e[n]), t[n] || {}), r;
  }, {})) : e;
}
function Ur(e, t) {
  return t ? Object.keys(e).reduce(function(r, n) {
    return r[n] = Fr(e[n], t[n]), r;
  }, _({}, e)) : e;
}
function ve(e) {
  return {
    create: function() {
      return {
        get: function(t) {
          return e[t];
        },
        set: function(t, r) {
          e[t] = r;
        }
      };
    }
  };
}
function jr(e) {
  return e === void 0 && (e = {
    number: {},
    dateTime: {},
    pluralRules: {}
  }), {
    getNumberFormat: N(function() {
      for (var t, r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return new ((t = Intl.NumberFormat).bind.apply(t, M([void 0], r, !1)))();
    }, {
      cache: ve(e.number),
      strategy: C.variadic
    }),
    getDateTimeFormat: N(function() {
      for (var t, r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return new ((t = Intl.DateTimeFormat).bind.apply(t, M([void 0], r, !1)))();
    }, {
      cache: ve(e.dateTime),
      strategy: C.variadic
    }),
    getPluralRules: N(function() {
      for (var t, r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return new ((t = Intl.PluralRules).bind.apply(t, M([void 0], r, !1)))();
    }, {
      cache: ve(e.pluralRules),
      strategy: C.variadic
    })
  };
}
var It = (
  /** @class */
  function() {
    function e(t, r, n, a) {
      var i = this;
      if (r === void 0 && (r = e.defaultLocale), this.formatterCache = {
        number: {},
        dateTime: {},
        pluralRules: {}
      }, this.format = function(u) {
        var c = i.formatToParts(u);
        if (c.length === 1)
          return c[0].value;
        var d = c.reduce(function(h, l) {
          return !h.length || l.type !== S.literal || typeof h[h.length - 1] != "string" ? h.push(l.value) : h[h.length - 1] += l.value, h;
        }, []);
        return d.length <= 1 ? d[0] || "" : d;
      }, this.formatToParts = function(u) {
        return se(i.ast, i.locales, i.formatters, i.formats, u, void 0, i.message);
      }, this.resolvedOptions = function() {
        var u;
        return {
          locale: ((u = i.resolvedLocale) === null || u === void 0 ? void 0 : u.toString()) || Intl.NumberFormat.supportedLocalesOf(i.locales)[0]
        };
      }, this.getAst = function() {
        return i.ast;
      }, this.locales = r, this.resolvedLocale = e.resolveLocale(r), typeof t == "string") {
        if (this.message = t, !e.__parse)
          throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
        var s = a || {};
        s.formatters;
        var o = Jt(s, ["formatters"]);
        this.ast = e.__parse(t, _(_({}, o), { locale: this.resolvedLocale }));
      } else
        this.ast = t;
      if (!Array.isArray(this.ast))
        throw new TypeError("A message must be provided as a String or AST.");
      this.formats = Ur(e.formats, n), this.formatters = a && a.formatters || jr(this.formatterCache);
    }
    return Object.defineProperty(e, "defaultLocale", {
      get: function() {
        return e.memoizedDefaultLocale || (e.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale), e.memoizedDefaultLocale;
      },
      enumerable: !1,
      configurable: !0
    }), e.memoizedDefaultLocale = null, e.resolveLocale = function(t) {
      if (typeof Intl.Locale != "undefined") {
        var r = Intl.NumberFormat.supportedLocalesOf(t);
        return r.length > 0 ? new Intl.Locale(r[0]) : new Intl.Locale(typeof t == "string" ? t : t[0]);
      }
    }, e.__parse = Ir, e.formats = {
      number: {
        integer: {
          maximumFractionDigits: 0
        },
        currency: {
          style: "currency"
        },
        percent: {
          style: "percent"
        }
      },
      date: {
        short: {
          month: "numeric",
          day: "numeric",
          year: "2-digit"
        },
        medium: {
          month: "short",
          day: "numeric",
          year: "numeric"
        },
        long: {
          month: "long",
          day: "numeric",
          year: "numeric"
        },
        full: {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric"
        }
      },
      time: {
        short: {
          hour: "numeric",
          minute: "numeric"
        },
        medium: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric"
        },
        long: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        },
        full: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        }
      }
    }, e;
  }()
), U;
(function(e) {
  e.FORMAT_ERROR = "FORMAT_ERROR", e.UNSUPPORTED_FORMATTER = "UNSUPPORTED_FORMATTER", e.INVALID_CONFIG = "INVALID_CONFIG", e.MISSING_DATA = "MISSING_DATA", e.MISSING_TRANSLATION = "MISSING_TRANSLATION";
})(U || (U = {}));
var ee = (
  /** @class */
  function(e) {
    I(t, e);
    function t(r, n, a) {
      var i = this, s = a ? a instanceof Error ? a : new Error(String(a)) : void 0;
      return i = e.call(this, "[@formatjs/intl Error ".concat(r, "] ").concat(n, `
`).concat(s ? `
`.concat(s.message, `
`).concat(s.stack) : "")) || this, i.code = r, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(i, t), i;
    }
    return t;
  }(Error)
), $r = (
  /** @class */
  function(e) {
    I(t, e);
    function t(r, n) {
      return e.call(this, U.UNSUPPORTED_FORMATTER, r, n) || this;
    }
    return t;
  }(ee)
), Vr = (
  /** @class */
  function(e) {
    I(t, e);
    function t(r, n) {
      return e.call(this, U.INVALID_CONFIG, r, n) || this;
    }
    return t;
  }(ee)
), Xe = (
  /** @class */
  function(e) {
    I(t, e);
    function t(r, n) {
      return e.call(this, U.MISSING_DATA, r, n) || this;
    }
    return t;
  }(ee)
), A = (
  /** @class */
  function(e) {
    I(t, e);
    function t(r, n, a) {
      var i = e.call(this, U.FORMAT_ERROR, "".concat(r, `
Locale: `).concat(n, `
`), a) || this;
      return i.locale = n, i;
    }
    return t;
  }(ee)
), pe = (
  /** @class */
  function(e) {
    I(t, e);
    function t(r, n, a, i) {
      var s = e.call(this, "".concat(r, `
MessageID: `).concat(a == null ? void 0 : a.id, `
Default Message: `).concat(a == null ? void 0 : a.defaultMessage, `
Description: `).concat(a == null ? void 0 : a.description, `
`), n, i) || this;
      return s.descriptor = a, s.locale = n, s;
    }
    return t;
  }(A)
), kr = (
  /** @class */
  function(e) {
    I(t, e);
    function t(r, n) {
      var a = e.call(this, U.MISSING_TRANSLATION, 'Missing message: "'.concat(r.id, '" for locale "').concat(n, '", using ').concat(r.defaultMessage ? "default message (".concat(typeof r.defaultMessage == "string" ? r.defaultMessage : r.defaultMessage.map(function(i) {
        var s;
        return (s = i.value) !== null && s !== void 0 ? s : JSON.stringify(i);
      }).join(), ")") : "id", " as fallback.")) || this;
      return a.descriptor = r, a;
    }
    return t;
  }(ee)
);
function j(e, t, r) {
  return r === void 0 && (r = {}), t.reduce(function(n, a) {
    return a in e ? n[a] = e[a] : a in r && (n[a] = r[a]), n;
  }, {});
}
var Zr = function(e) {
  process.env.NODE_ENV !== "production" && console.error(e);
}, qr = function(e) {
  process.env.NODE_ENV !== "production" && console.warn(e);
}, zr = {
  formats: {},
  messages: {},
  timeZone: void 0,
  defaultLocale: "en",
  defaultFormats: {},
  fallbackOnEmptyString: !0,
  onError: Zr,
  onWarn: qr
};
function Ht() {
  return {
    dateTime: {},
    number: {},
    message: {},
    relativeTime: {},
    pluralRules: {},
    list: {},
    displayNames: {}
  };
}
function D(e) {
  return {
    create: function() {
      return {
        get: function(t) {
          return e[t];
        },
        set: function(t, r) {
          e[t] = r;
        }
      };
    }
  };
}
function Kr(e) {
  e === void 0 && (e = Ht());
  var t = Intl.RelativeTimeFormat, r = Intl.ListFormat, n = Intl.DisplayNames, a = N(function() {
    for (var o, u = [], c = 0; c < arguments.length; c++)
      u[c] = arguments[c];
    return new ((o = Intl.DateTimeFormat).bind.apply(o, M([void 0], u, !1)))();
  }, {
    cache: D(e.dateTime),
    strategy: C.variadic
  }), i = N(function() {
    for (var o, u = [], c = 0; c < arguments.length; c++)
      u[c] = arguments[c];
    return new ((o = Intl.NumberFormat).bind.apply(o, M([void 0], u, !1)))();
  }, {
    cache: D(e.number),
    strategy: C.variadic
  }), s = N(function() {
    for (var o, u = [], c = 0; c < arguments.length; c++)
      u[c] = arguments[c];
    return new ((o = Intl.PluralRules).bind.apply(o, M([void 0], u, !1)))();
  }, {
    cache: D(e.pluralRules),
    strategy: C.variadic
  });
  return {
    getDateTimeFormat: a,
    getNumberFormat: i,
    getMessageFormat: N(function(o, u, c, d) {
      return new It(o, u, c, _({ formatters: {
        getNumberFormat: i,
        getDateTimeFormat: a,
        getPluralRules: s
      } }, d || {}));
    }, {
      cache: D(e.message),
      strategy: C.variadic
    }),
    getRelativeTimeFormat: N(function() {
      for (var o = [], u = 0; u < arguments.length; u++)
        o[u] = arguments[u];
      return new (t.bind.apply(t, M([void 0], o, !1)))();
    }, {
      cache: D(e.relativeTime),
      strategy: C.variadic
    }),
    getPluralRules: s,
    getListFormat: N(function() {
      for (var o = [], u = 0; u < arguments.length; u++)
        o[u] = arguments[u];
      return new (r.bind.apply(r, M([void 0], o, !1)))();
    }, {
      cache: D(e.list),
      strategy: C.variadic
    }),
    getDisplayNames: N(function() {
      for (var o = [], u = 0; u < arguments.length; u++)
        o[u] = arguments[u];
      return new (n.bind.apply(n, M([void 0], o, !1)))();
    }, {
      cache: D(e.displayNames),
      strategy: C.variadic
    })
  };
}
function Be(e, t, r, n) {
  var a = e && e[t], i;
  if (a && (i = a[r]), i)
    return i;
  n(new $r("No ".concat(t, " format named: ").concat(r)));
}
function Wr(e, t, r) {
  if (r === void 0 && (r = Error), !e)
    throw new r(t);
}
function Xr(e) {
  return Intl.getCanonicalLocales(e);
}
var be = {
  supplemental: {
    languageMatching: {
      "written-new": [
        {
          paradigmLocales: {
            _locales: "en en_GB es es_419 pt_BR pt_PT"
          }
        },
        {
          $enUS: {
            _value: "AS+CA+GU+MH+MP+PH+PR+UM+US+VI"
          }
        },
        {
          $cnsar: {
            _value: "HK+MO"
          }
        },
        {
          $americas: {
            _value: "019"
          }
        },
        {
          $maghreb: {
            _value: "MA+DZ+TN+LY+MR+EH"
          }
        },
        {
          no: {
            _desired: "nb",
            _distance: "1"
          }
        },
        {
          bs: {
            _desired: "hr",
            _distance: "4"
          }
        },
        {
          bs: {
            _desired: "sh",
            _distance: "4"
          }
        },
        {
          hr: {
            _desired: "sh",
            _distance: "4"
          }
        },
        {
          sr: {
            _desired: "sh",
            _distance: "4"
          }
        },
        {
          aa: {
            _desired: "ssy",
            _distance: "4"
          }
        },
        {
          de: {
            _desired: "gsw",
            _distance: "4",
            _oneway: "true"
          }
        },
        {
          de: {
            _desired: "lb",
            _distance: "4",
            _oneway: "true"
          }
        },
        {
          no: {
            _desired: "da",
            _distance: "8"
          }
        },
        {
          nb: {
            _desired: "da",
            _distance: "8"
          }
        },
        {
          ru: {
            _desired: "ab",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ach",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          nl: {
            _desired: "af",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ak",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "am",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "ay",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "az",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ur: {
            _desired: "bal",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "be",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "bem",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          hi: {
            _desired: "bh",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "bn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "bo",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "br",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "ca",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          fil: {
            _desired: "ceb",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "chr",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ckb",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "co",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "crs",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          sk: {
            _desired: "cs",
            _distance: "20"
          }
        },
        {
          en: {
            _desired: "cy",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ee",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "eo",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "eu",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          da: {
            _desired: "fo",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          nl: {
            _desired: "fy",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ga",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "gaa",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "gd",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "gl",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "gn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          hi: {
            _desired: "gu",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ha",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "haw",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "ht",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "hy",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ia",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ig",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "is",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          id: {
            _desired: "jv",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ka",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "kg",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "kk",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "km",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "kn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "kri",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          tr: {
            _desired: "ku",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "ky",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          it: {
            _desired: "la",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "lg",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "ln",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "lo",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "loz",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "lua",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          hi: {
            _desired: "mai",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "mfe",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "mg",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "mi",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ml",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "mn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          hi: {
            _desired: "mr",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          id: {
            _desired: "ms",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "mt",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "my",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ne",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          nb: {
            _desired: "nn",
            _distance: "20"
          }
        },
        {
          no: {
            _desired: "nn",
            _distance: "20"
          }
        },
        {
          en: {
            _desired: "nso",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ny",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "nyn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "oc",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "om",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "or",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "pa",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "pcm",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ps",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "qu",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          de: {
            _desired: "rm",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "rn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "rw",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          hi: {
            _desired: "sa",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "sd",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "si",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "sn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "so",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "sq",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "st",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          id: {
            _desired: "su",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "sw",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ta",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "te",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "tg",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ti",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "tk",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "tlh",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "tn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "to",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "tt",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "tum",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "ug",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "uk",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ur",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "uz",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "wo",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "xh",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "yi",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "yo",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "za",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "zu",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "aao",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "abh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "abv",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "acm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "acq",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "acw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "acx",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "acy",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "adf",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "aeb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "aec",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "afb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ajp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "apc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "apd",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "arq",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ars",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ary",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "arz",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "auz",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "avl",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ayh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ayl",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ayn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ayp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "bbz",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "pga",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "shu",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ssh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          az: {
            _desired: "azb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          et: {
            _desired: "vro",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "ffm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fub",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fue",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fuf",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fuh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fui",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fuq",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fuv",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          gn: {
            _desired: "gnw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          gn: {
            _desired: "gui",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          gn: {
            _desired: "gun",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          gn: {
            _desired: "nhd",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          iu: {
            _desired: "ikt",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "enb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "eyo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "niq",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "oki",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "pko",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "sgc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "tec",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "tuy",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kok: {
            _desired: "gom",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kpe: {
            _desired: "gkp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "ida",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lkb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lko",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lks",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lri",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lrm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lsm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lto",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lts",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lwg",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "nle",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "nyd",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "rag",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          lv: {
            _desired: "ltg",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "bhr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "bjq",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "bmm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "bzc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "msh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "skg",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "tdx",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "tkg",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "txy",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "xmv",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "xmw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mn: {
            _desired: "mvf",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "bjn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "btj",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "bve",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "bvu",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "coa",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "dup",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "hji",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "id",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "jak",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "jax",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "kvb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "kvr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "kxd",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "lce",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "lcf",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "liw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "max",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "meo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "mfa",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "mfb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "min",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "mqg",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "msi",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "mui",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "orn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "ors",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "pel",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "pse",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "tmw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "urk",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "vkk",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "vkt",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "xmm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "zlm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "zmi",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ne: {
            _desired: "dty",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          om: {
            _desired: "gax",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          om: {
            _desired: "hae",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          om: {
            _desired: "orc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          or: {
            _desired: "spv",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ps: {
            _desired: "pbt",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ps: {
            _desired: "pst",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qub",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qud",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "quf",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qug",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "quh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "quk",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qul",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qup",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qur",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qus",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "quw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qux",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "quy",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qva",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qve",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvi",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvj",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvl",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvs",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvz",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qwa",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qwc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qwh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qws",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxa",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxl",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxt",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxu",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sc: {
            _desired: "sdc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sc: {
            _desired: "sdn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sc: {
            _desired: "sro",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sq: {
            _desired: "aae",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sq: {
            _desired: "aat",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sq: {
            _desired: "aln",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          syr: {
            _desired: "aii",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          uz: {
            _desired: "uzs",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          yi: {
            _desired: "yih",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "cdo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "cjy",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "cpx",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "czh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "czo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "gan",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "hak",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "hsn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "lzh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "mnp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "nan",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "wuu",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "yue",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "*": {
            _desired: "*",
            _distance: "80"
          }
        },
        {
          "en-Latn": {
            _desired: "am-Ethi",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "ru-Cyrl": {
            _desired: "az-Latn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "bn-Beng",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "zh-Hans": {
            _desired: "bo-Tibt",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "ru-Cyrl": {
            _desired: "hy-Armn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ka-Geor",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "km-Khmr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "kn-Knda",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "lo-Laoo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ml-Mlym",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "my-Mymr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ne-Deva",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "or-Orya",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "pa-Guru",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ps-Arab",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "sd-Arab",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "si-Sinh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ta-Taml",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "te-Telu",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ti-Ethi",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "ru-Cyrl": {
            _desired: "tk-Latn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ur-Arab",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "ru-Cyrl": {
            _desired: "uz-Latn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "yi-Hebr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "sr-Cyrl": {
            _desired: "sr-Latn",
            _distance: "5"
          }
        },
        {
          "zh-Hans": {
            _desired: "za-Latn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "zh-Hans": {
            _desired: "zh-Hani",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "zh-Hant": {
            _desired: "zh-Hani",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "ar-Arab": {
            _desired: "ar-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "bn-Beng": {
            _desired: "bn-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "gu-Gujr": {
            _desired: "gu-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "hi-Deva": {
            _desired: "hi-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "kn-Knda": {
            _desired: "kn-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "ml-Mlym": {
            _desired: "ml-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "mr-Deva": {
            _desired: "mr-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "ta-Taml": {
            _desired: "ta-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "te-Telu": {
            _desired: "te-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "zh-Hans": {
            _desired: "zh-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "ja-Jpan": {
            _desired: "ja-Latn",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Jpan": {
            _desired: "ja-Hani",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Jpan": {
            _desired: "ja-Hira",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Jpan": {
            _desired: "ja-Kana",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Jpan": {
            _desired: "ja-Hrkt",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Hrkt": {
            _desired: "ja-Hira",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Hrkt": {
            _desired: "ja-Kana",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ko-Kore": {
            _desired: "ko-Hani",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ko-Kore": {
            _desired: "ko-Hang",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ko-Kore": {
            _desired: "ko-Jamo",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ko-Hang": {
            _desired: "ko-Jamo",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "*-*": {
            _desired: "*-*",
            _distance: "50"
          }
        },
        {
          "ar-*-$maghreb": {
            _desired: "ar-*-$maghreb",
            _distance: "4"
          }
        },
        {
          "ar-*-$!maghreb": {
            _desired: "ar-*-$!maghreb",
            _distance: "4"
          }
        },
        {
          "ar-*-*": {
            _desired: "ar-*-*",
            _distance: "5"
          }
        },
        {
          "en-*-$enUS": {
            _desired: "en-*-$enUS",
            _distance: "4"
          }
        },
        {
          "en-*-GB": {
            _desired: "en-*-$!enUS",
            _distance: "3"
          }
        },
        {
          "en-*-$!enUS": {
            _desired: "en-*-$!enUS",
            _distance: "4"
          }
        },
        {
          "en-*-*": {
            _desired: "en-*-*",
            _distance: "5"
          }
        },
        {
          "es-*-$americas": {
            _desired: "es-*-$americas",
            _distance: "4"
          }
        },
        {
          "es-*-$!americas": {
            _desired: "es-*-$!americas",
            _distance: "4"
          }
        },
        {
          "es-*-*": {
            _desired: "es-*-*",
            _distance: "5"
          }
        },
        {
          "pt-*-$americas": {
            _desired: "pt-*-$americas",
            _distance: "4"
          }
        },
        {
          "pt-*-$!americas": {
            _desired: "pt-*-$!americas",
            _distance: "4"
          }
        },
        {
          "pt-*-*": {
            _desired: "pt-*-*",
            _distance: "5"
          }
        },
        {
          "zh-Hant-$cnsar": {
            _desired: "zh-Hant-$cnsar",
            _distance: "4"
          }
        },
        {
          "zh-Hant-$!cnsar": {
            _desired: "zh-Hant-$!cnsar",
            _distance: "4"
          }
        },
        {
          "zh-Hant-*": {
            _desired: "zh-Hant-*",
            _distance: "5"
          }
        },
        {
          "*-*-*": {
            _desired: "*-*-*",
            _distance: "4"
          }
        }
      ]
    }
  }
}, Yr = {
  "001": [
    "001",
    "001-status-grouping",
    "002",
    "005",
    "009",
    "011",
    "013",
    "014",
    "015",
    "017",
    "018",
    "019",
    "021",
    "029",
    "030",
    "034",
    "035",
    "039",
    "053",
    "054",
    "057",
    "061",
    "142",
    "143",
    "145",
    "150",
    "151",
    "154",
    "155",
    "AC",
    "AD",
    "AE",
    "AF",
    "AG",
    "AI",
    "AL",
    "AM",
    "AO",
    "AQ",
    "AR",
    "AS",
    "AT",
    "AU",
    "AW",
    "AX",
    "AZ",
    "BA",
    "BB",
    "BD",
    "BE",
    "BF",
    "BG",
    "BH",
    "BI",
    "BJ",
    "BL",
    "BM",
    "BN",
    "BO",
    "BQ",
    "BR",
    "BS",
    "BT",
    "BV",
    "BW",
    "BY",
    "BZ",
    "CA",
    "CC",
    "CD",
    "CF",
    "CG",
    "CH",
    "CI",
    "CK",
    "CL",
    "CM",
    "CN",
    "CO",
    "CP",
    "CQ",
    "CR",
    "CU",
    "CV",
    "CW",
    "CX",
    "CY",
    "CZ",
    "DE",
    "DG",
    "DJ",
    "DK",
    "DM",
    "DO",
    "DZ",
    "EA",
    "EC",
    "EE",
    "EG",
    "EH",
    "ER",
    "ES",
    "ET",
    "EU",
    "EZ",
    "FI",
    "FJ",
    "FK",
    "FM",
    "FO",
    "FR",
    "GA",
    "GB",
    "GD",
    "GE",
    "GF",
    "GG",
    "GH",
    "GI",
    "GL",
    "GM",
    "GN",
    "GP",
    "GQ",
    "GR",
    "GS",
    "GT",
    "GU",
    "GW",
    "GY",
    "HK",
    "HM",
    "HN",
    "HR",
    "HT",
    "HU",
    "IC",
    "ID",
    "IE",
    "IL",
    "IM",
    "IN",
    "IO",
    "IQ",
    "IR",
    "IS",
    "IT",
    "JE",
    "JM",
    "JO",
    "JP",
    "KE",
    "KG",
    "KH",
    "KI",
    "KM",
    "KN",
    "KP",
    "KR",
    "KW",
    "KY",
    "KZ",
    "LA",
    "LB",
    "LC",
    "LI",
    "LK",
    "LR",
    "LS",
    "LT",
    "LU",
    "LV",
    "LY",
    "MA",
    "MC",
    "MD",
    "ME",
    "MF",
    "MG",
    "MH",
    "MK",
    "ML",
    "MM",
    "MN",
    "MO",
    "MP",
    "MQ",
    "MR",
    "MS",
    "MT",
    "MU",
    "MV",
    "MW",
    "MX",
    "MY",
    "MZ",
    "NA",
    "NC",
    "NE",
    "NF",
    "NG",
    "NI",
    "NL",
    "NO",
    "NP",
    "NR",
    "NU",
    "NZ",
    "OM",
    "PA",
    "PE",
    "PF",
    "PG",
    "PH",
    "PK",
    "PL",
    "PM",
    "PN",
    "PR",
    "PS",
    "PT",
    "PW",
    "PY",
    "QA",
    "QO",
    "RE",
    "RO",
    "RS",
    "RU",
    "RW",
    "SA",
    "SB",
    "SC",
    "SD",
    "SE",
    "SG",
    "SH",
    "SI",
    "SJ",
    "SK",
    "SL",
    "SM",
    "SN",
    "SO",
    "SR",
    "SS",
    "ST",
    "SV",
    "SX",
    "SY",
    "SZ",
    "TA",
    "TC",
    "TD",
    "TF",
    "TG",
    "TH",
    "TJ",
    "TK",
    "TL",
    "TM",
    "TN",
    "TO",
    "TR",
    "TT",
    "TV",
    "TW",
    "TZ",
    "UA",
    "UG",
    "UM",
    "UN",
    "US",
    "UY",
    "UZ",
    "VA",
    "VC",
    "VE",
    "VG",
    "VI",
    "VN",
    "VU",
    "WF",
    "WS",
    "XK",
    "YE",
    "YT",
    "ZA",
    "ZM",
    "ZW"
  ],
  "002": [
    "002",
    "002-status-grouping",
    "011",
    "014",
    "015",
    "017",
    "018",
    "202",
    "AO",
    "BF",
    "BI",
    "BJ",
    "BW",
    "CD",
    "CF",
    "CG",
    "CI",
    "CM",
    "CV",
    "DJ",
    "DZ",
    "EA",
    "EG",
    "EH",
    "ER",
    "ET",
    "GA",
    "GH",
    "GM",
    "GN",
    "GQ",
    "GW",
    "IC",
    "IO",
    "KE",
    "KM",
    "LR",
    "LS",
    "LY",
    "MA",
    "MG",
    "ML",
    "MR",
    "MU",
    "MW",
    "MZ",
    "NA",
    "NE",
    "NG",
    "RE",
    "RW",
    "SC",
    "SD",
    "SH",
    "SL",
    "SN",
    "SO",
    "SS",
    "ST",
    "SZ",
    "TD",
    "TF",
    "TG",
    "TN",
    "TZ",
    "UG",
    "YT",
    "ZA",
    "ZM",
    "ZW"
  ],
  "003": [
    "003",
    "013",
    "021",
    "029",
    "AG",
    "AI",
    "AW",
    "BB",
    "BL",
    "BM",
    "BQ",
    "BS",
    "BZ",
    "CA",
    "CR",
    "CU",
    "CW",
    "DM",
    "DO",
    "GD",
    "GL",
    "GP",
    "GT",
    "HN",
    "HT",
    "JM",
    "KN",
    "KY",
    "LC",
    "MF",
    "MQ",
    "MS",
    "MX",
    "NI",
    "PA",
    "PM",
    "PR",
    "SV",
    "SX",
    "TC",
    "TT",
    "US",
    "VC",
    "VG",
    "VI"
  ],
  "005": [
    "005",
    "AR",
    "BO",
    "BR",
    "BV",
    "CL",
    "CO",
    "EC",
    "FK",
    "GF",
    "GS",
    "GY",
    "PE",
    "PY",
    "SR",
    "UY",
    "VE"
  ],
  "009": [
    "009",
    "053",
    "054",
    "057",
    "061",
    "AC",
    "AQ",
    "AS",
    "AU",
    "CC",
    "CK",
    "CP",
    "CX",
    "DG",
    "FJ",
    "FM",
    "GU",
    "HM",
    "KI",
    "MH",
    "MP",
    "NC",
    "NF",
    "NR",
    "NU",
    "NZ",
    "PF",
    "PG",
    "PN",
    "PW",
    "QO",
    "SB",
    "TA",
    "TK",
    "TO",
    "TV",
    "UM",
    "VU",
    "WF",
    "WS"
  ],
  "011": [
    "011",
    "BF",
    "BJ",
    "CI",
    "CV",
    "GH",
    "GM",
    "GN",
    "GW",
    "LR",
    "ML",
    "MR",
    "NE",
    "NG",
    "SH",
    "SL",
    "SN",
    "TG"
  ],
  "013": [
    "013",
    "BZ",
    "CR",
    "GT",
    "HN",
    "MX",
    "NI",
    "PA",
    "SV"
  ],
  "014": [
    "014",
    "BI",
    "DJ",
    "ER",
    "ET",
    "IO",
    "KE",
    "KM",
    "MG",
    "MU",
    "MW",
    "MZ",
    "RE",
    "RW",
    "SC",
    "SO",
    "SS",
    "TF",
    "TZ",
    "UG",
    "YT",
    "ZM",
    "ZW"
  ],
  "015": [
    "015",
    "DZ",
    "EA",
    "EG",
    "EH",
    "IC",
    "LY",
    "MA",
    "SD",
    "TN"
  ],
  "017": [
    "017",
    "AO",
    "CD",
    "CF",
    "CG",
    "CM",
    "GA",
    "GQ",
    "ST",
    "TD"
  ],
  "018": [
    "018",
    "BW",
    "LS",
    "NA",
    "SZ",
    "ZA"
  ],
  "019": [
    "003",
    "005",
    "013",
    "019",
    "019-status-grouping",
    "021",
    "029",
    "419",
    "AG",
    "AI",
    "AR",
    "AW",
    "BB",
    "BL",
    "BM",
    "BO",
    "BQ",
    "BR",
    "BS",
    "BV",
    "BZ",
    "CA",
    "CL",
    "CO",
    "CR",
    "CU",
    "CW",
    "DM",
    "DO",
    "EC",
    "FK",
    "GD",
    "GF",
    "GL",
    "GP",
    "GS",
    "GT",
    "GY",
    "HN",
    "HT",
    "JM",
    "KN",
    "KY",
    "LC",
    "MF",
    "MQ",
    "MS",
    "MX",
    "NI",
    "PA",
    "PE",
    "PM",
    "PR",
    "PY",
    "SR",
    "SV",
    "SX",
    "TC",
    "TT",
    "US",
    "UY",
    "VC",
    "VE",
    "VG",
    "VI"
  ],
  "021": [
    "021",
    "BM",
    "CA",
    "GL",
    "PM",
    "US"
  ],
  "029": [
    "029",
    "AG",
    "AI",
    "AW",
    "BB",
    "BL",
    "BQ",
    "BS",
    "CU",
    "CW",
    "DM",
    "DO",
    "GD",
    "GP",
    "HT",
    "JM",
    "KN",
    "KY",
    "LC",
    "MF",
    "MQ",
    "MS",
    "PR",
    "SX",
    "TC",
    "TT",
    "VC",
    "VG",
    "VI"
  ],
  "030": [
    "030",
    "CN",
    "HK",
    "JP",
    "KP",
    "KR",
    "MN",
    "MO",
    "TW"
  ],
  "034": [
    "034",
    "AF",
    "BD",
    "BT",
    "IN",
    "IR",
    "LK",
    "MV",
    "NP",
    "PK"
  ],
  "035": [
    "035",
    "BN",
    "ID",
    "KH",
    "LA",
    "MM",
    "MY",
    "PH",
    "SG",
    "TH",
    "TL",
    "VN"
  ],
  "039": [
    "039",
    "AD",
    "AL",
    "BA",
    "ES",
    "GI",
    "GR",
    "HR",
    "IT",
    "ME",
    "MK",
    "MT",
    "PT",
    "RS",
    "SI",
    "SM",
    "VA",
    "XK"
  ],
  "053": [
    "053",
    "AU",
    "CC",
    "CX",
    "HM",
    "NF",
    "NZ"
  ],
  "054": [
    "054",
    "FJ",
    "NC",
    "PG",
    "SB",
    "VU"
  ],
  "057": [
    "057",
    "FM",
    "GU",
    "KI",
    "MH",
    "MP",
    "NR",
    "PW",
    "UM"
  ],
  "061": [
    "061",
    "AS",
    "CK",
    "NU",
    "PF",
    "PN",
    "TK",
    "TO",
    "TV",
    "WF",
    "WS"
  ],
  142: [
    "030",
    "034",
    "035",
    "142",
    "143",
    "145",
    "AE",
    "AF",
    "AM",
    "AZ",
    "BD",
    "BH",
    "BN",
    "BT",
    "CN",
    "CY",
    "GE",
    "HK",
    "ID",
    "IL",
    "IN",
    "IQ",
    "IR",
    "JO",
    "JP",
    "KG",
    "KH",
    "KP",
    "KR",
    "KW",
    "KZ",
    "LA",
    "LB",
    "LK",
    "MM",
    "MN",
    "MO",
    "MV",
    "MY",
    "NP",
    "OM",
    "PH",
    "PK",
    "PS",
    "QA",
    "SA",
    "SG",
    "SY",
    "TH",
    "TJ",
    "TL",
    "TM",
    "TR",
    "TW",
    "UZ",
    "VN",
    "YE"
  ],
  143: [
    "143",
    "KG",
    "KZ",
    "TJ",
    "TM",
    "UZ"
  ],
  145: [
    "145",
    "AE",
    "AM",
    "AZ",
    "BH",
    "CY",
    "GE",
    "IL",
    "IQ",
    "JO",
    "KW",
    "LB",
    "OM",
    "PS",
    "QA",
    "SA",
    "SY",
    "TR",
    "YE"
  ],
  150: [
    "039",
    "150",
    "151",
    "154",
    "155",
    "AD",
    "AL",
    "AT",
    "AX",
    "BA",
    "BE",
    "BG",
    "BY",
    "CH",
    "CQ",
    "CZ",
    "DE",
    "DK",
    "EE",
    "ES",
    "FI",
    "FO",
    "FR",
    "GB",
    "GG",
    "GI",
    "GR",
    "HR",
    "HU",
    "IE",
    "IM",
    "IS",
    "IT",
    "JE",
    "LI",
    "LT",
    "LU",
    "LV",
    "MC",
    "MD",
    "ME",
    "MK",
    "MT",
    "NL",
    "NO",
    "PL",
    "PT",
    "RO",
    "RS",
    "RU",
    "SE",
    "SI",
    "SJ",
    "SK",
    "SM",
    "UA",
    "VA",
    "XK"
  ],
  151: [
    "151",
    "BG",
    "BY",
    "CZ",
    "HU",
    "MD",
    "PL",
    "RO",
    "RU",
    "SK",
    "UA"
  ],
  154: [
    "154",
    "AX",
    "CQ",
    "DK",
    "EE",
    "FI",
    "FO",
    "GB",
    "GG",
    "IE",
    "IM",
    "IS",
    "JE",
    "LT",
    "LV",
    "NO",
    "SE",
    "SJ"
  ],
  155: [
    "155",
    "AT",
    "BE",
    "CH",
    "DE",
    "FR",
    "LI",
    "LU",
    "MC",
    "NL"
  ],
  202: [
    "011",
    "014",
    "017",
    "018",
    "202",
    "AO",
    "BF",
    "BI",
    "BJ",
    "BW",
    "CD",
    "CF",
    "CG",
    "CI",
    "CM",
    "CV",
    "DJ",
    "ER",
    "ET",
    "GA",
    "GH",
    "GM",
    "GN",
    "GQ",
    "GW",
    "IO",
    "KE",
    "KM",
    "LR",
    "LS",
    "MG",
    "ML",
    "MR",
    "MU",
    "MW",
    "MZ",
    "NA",
    "NE",
    "NG",
    "RE",
    "RW",
    "SC",
    "SH",
    "SL",
    "SN",
    "SO",
    "SS",
    "ST",
    "SZ",
    "TD",
    "TF",
    "TG",
    "TZ",
    "UG",
    "YT",
    "ZA",
    "ZM",
    "ZW"
  ],
  419: [
    "005",
    "013",
    "029",
    "419",
    "AG",
    "AI",
    "AR",
    "AW",
    "BB",
    "BL",
    "BO",
    "BQ",
    "BR",
    "BS",
    "BV",
    "BZ",
    "CL",
    "CO",
    "CR",
    "CU",
    "CW",
    "DM",
    "DO",
    "EC",
    "FK",
    "GD",
    "GF",
    "GP",
    "GS",
    "GT",
    "GY",
    "HN",
    "HT",
    "JM",
    "KN",
    "KY",
    "LC",
    "MF",
    "MQ",
    "MS",
    "MX",
    "NI",
    "PA",
    "PE",
    "PR",
    "PY",
    "SR",
    "SV",
    "SX",
    "TC",
    "TT",
    "UY",
    "VC",
    "VE",
    "VG",
    "VI"
  ],
  EU: [
    "AT",
    "BE",
    "BG",
    "CY",
    "CZ",
    "DE",
    "DK",
    "EE",
    "ES",
    "EU",
    "FI",
    "FR",
    "GR",
    "HR",
    "HU",
    "IE",
    "IT",
    "LT",
    "LU",
    "LV",
    "MT",
    "NL",
    "PL",
    "PT",
    "RO",
    "SE",
    "SI",
    "SK"
  ],
  EZ: [
    "AT",
    "BE",
    "CY",
    "DE",
    "EE",
    "ES",
    "EZ",
    "FI",
    "FR",
    "GR",
    "IE",
    "IT",
    "LT",
    "LU",
    "LV",
    "MT",
    "NL",
    "PT",
    "SI",
    "SK"
  ],
  QO: [
    "AC",
    "AQ",
    "CP",
    "DG",
    "QO",
    "TA"
  ],
  UN: [
    "AD",
    "AE",
    "AF",
    "AG",
    "AL",
    "AM",
    "AO",
    "AR",
    "AT",
    "AU",
    "AZ",
    "BA",
    "BB",
    "BD",
    "BE",
    "BF",
    "BG",
    "BH",
    "BI",
    "BJ",
    "BN",
    "BO",
    "BR",
    "BS",
    "BT",
    "BW",
    "BY",
    "BZ",
    "CA",
    "CD",
    "CF",
    "CG",
    "CH",
    "CI",
    "CL",
    "CM",
    "CN",
    "CO",
    "CR",
    "CU",
    "CV",
    "CY",
    "CZ",
    "DE",
    "DJ",
    "DK",
    "DM",
    "DO",
    "DZ",
    "EC",
    "EE",
    "EG",
    "ER",
    "ES",
    "ET",
    "FI",
    "FJ",
    "FM",
    "FR",
    "GA",
    "GB",
    "GD",
    "GE",
    "GH",
    "GM",
    "GN",
    "GQ",
    "GR",
    "GT",
    "GW",
    "GY",
    "HN",
    "HR",
    "HT",
    "HU",
    "ID",
    "IE",
    "IL",
    "IN",
    "IQ",
    "IR",
    "IS",
    "IT",
    "JM",
    "JO",
    "JP",
    "KE",
    "KG",
    "KH",
    "KI",
    "KM",
    "KN",
    "KP",
    "KR",
    "KW",
    "KZ",
    "LA",
    "LB",
    "LC",
    "LI",
    "LK",
    "LR",
    "LS",
    "LT",
    "LU",
    "LV",
    "LY",
    "MA",
    "MC",
    "MD",
    "ME",
    "MG",
    "MH",
    "MK",
    "ML",
    "MM",
    "MN",
    "MR",
    "MT",
    "MU",
    "MV",
    "MW",
    "MX",
    "MY",
    "MZ",
    "NA",
    "NE",
    "NG",
    "NI",
    "NL",
    "NO",
    "NP",
    "NR",
    "NZ",
    "OM",
    "PA",
    "PE",
    "PG",
    "PH",
    "PK",
    "PL",
    "PT",
    "PW",
    "PY",
    "QA",
    "RO",
    "RS",
    "RU",
    "RW",
    "SA",
    "SB",
    "SC",
    "SD",
    "SE",
    "SG",
    "SI",
    "SK",
    "SL",
    "SM",
    "SN",
    "SO",
    "SR",
    "SS",
    "ST",
    "SV",
    "SY",
    "SZ",
    "TD",
    "TG",
    "TH",
    "TJ",
    "TL",
    "TM",
    "TN",
    "TO",
    "TR",
    "TT",
    "TV",
    "TZ",
    "UA",
    "UG",
    "UN",
    "US",
    "UY",
    "UZ",
    "VC",
    "VE",
    "VN",
    "VU",
    "WS",
    "YE",
    "ZA",
    "ZM",
    "ZW"
  ]
}, Nt = /-u(?:-[0-9a-z]{2,8})+/gi;
function V(e, t, r) {
  if (r === void 0 && (r = Error), !e)
    throw new r(t);
}
var Jr = 838, Ee;
function Qr() {
  var e, t;
  if (!Ee) {
    var r = (t = (e = be.supplemental.languageMatching["written-new"][0]) === null || e === void 0 ? void 0 : e.paradigmLocales) === null || t === void 0 ? void 0 : t._locales.split(" "), n = be.supplemental.languageMatching["written-new"].slice(1, 5), a = be.supplemental.languageMatching["written-new"].slice(5), i = a.map(function(s) {
      var o = Object.keys(s)[0], u = s[o];
      return {
        supported: o,
        desired: u._desired,
        distance: +u._distance,
        oneway: u.oneway === "true"
      };
    }, {});
    Ee = {
      matches: i,
      matchVariables: n.reduce(function(s, o) {
        var u = Object.keys(o)[0], c = o[u];
        return s[u.slice(1)] = c._value.split("+"), s;
      }, {}),
      paradigmLocales: M(M([], r, !0), r.map(function(s) {
        return new Intl.Locale(s.replace(/_/g, "-")).maximize().toString();
      }), !0)
    };
  }
  return Ee;
}
function ne(e, t, r) {
  var n = t.split("-"), a = n[0], i = n[1], s = n[2], o = !0;
  if (s && s[0] === "$") {
    var u = s[1] !== "!", c = u ? r[s.slice(1)] : r[s.slice(2)], d = c.map(function(h) {
      return Yr[h] || [h];
    }).reduce(function(h, l) {
      return M(M([], h, !0), l, !0);
    }, []);
    o && (o = d.indexOf(e.region || "") > 1 == u);
  } else
    o && (o = e.region ? s === "*" || s === e.region : !0);
  return o && (o = e.script ? i === "*" || i === e.script : !0), o && (o = e.language ? a === "*" || a === e.language : !0), o;
}
function Ye(e) {
  return [e.language, e.script, e.region].filter(Boolean).join("-");
}
function we(e, t, r) {
  for (var n = 0, a = r.matches; n < a.length; n++) {
    var i = a[n], s = ne(e, i.desired, r.matchVariables) && ne(t, i.supported, r.matchVariables);
    if (!i.oneway && !s && (s = ne(e, i.supported, r.matchVariables) && ne(t, i.desired, r.matchVariables)), s) {
      var o = i.distance * 10;
      return r.paradigmLocales.indexOf(Ye(e)) > -1 != r.paradigmLocales.indexOf(Ye(t)) > -1 ? o - 1 : o;
    }
  }
  throw new Error("No matching distance found");
}
function en(e, t) {
  var r = new Intl.Locale(e).maximize(), n = new Intl.Locale(t).maximize(), a = {
    language: r.language,
    script: r.script || "",
    region: r.region || ""
  }, i = {
    language: n.language,
    script: n.script || "",
    region: n.region || ""
  }, s = 0, o = Qr();
  return a.language !== i.language && (s += we({
    language: r.language,
    script: "",
    region: ""
  }, {
    language: n.language,
    script: "",
    region: ""
  }, o)), a.script !== i.script && (s += we({
    language: r.language,
    script: a.script,
    region: ""
  }, {
    language: n.language,
    script: a.script,
    region: ""
  }, o)), a.region !== i.region && (s += we(a, i, o)), s;
}
function tn(e, t, r) {
  r === void 0 && (r = Jr);
  var n = 1 / 0, a = {
    matchedDesiredLocale: "",
    distances: {}
  };
  return e.forEach(function(i, s) {
    a.distances[i] || (a.distances[i] = {}), t.forEach(function(o) {
      var u = en(i, o) + 0 + s * 40;
      a.distances[i][o] = u, u < n && (n = u, a.matchedDesiredLocale = i, a.matchedSupportedLocale = o);
    });
  }), n >= r && (a.matchedDesiredLocale = void 0, a.matchedSupportedLocale = void 0), a;
}
function rn(e, t, r) {
  var n, a, i = [], s = t.reduce(function(u, c) {
    var d = c.replace(Nt, "");
    return i.push(d), u[d] = c, u;
  }, {}), o = tn(i, e);
  return o.matchedSupportedLocale && o.matchedDesiredLocale && (n = o.matchedSupportedLocale, a = s[o.matchedDesiredLocale].slice(o.matchedDesiredLocale.length) || void 0), n ? {
    locale: n,
    extension: a
  } : { locale: r() };
}
function nn(e, t) {
  for (var r = t; ; ) {
    if (e.indexOf(r) > -1)
      return r;
    var n = r.lastIndexOf("-");
    if (!~n)
      return;
    n >= 2 && r[n - 2] === "-" && (n -= 2), r = r.slice(0, n);
  }
}
function an(e, t, r) {
  for (var n = { locale: "" }, a = 0, i = t; a < i.length; a++) {
    var s = i[a], o = s.replace(Nt, ""), u = nn(e, o);
    if (u)
      return n.locale = u, s !== o && (n.extension = s.slice(o.length, s.length)), n;
  }
  return n.locale = r(), n;
}
function sn(e, t) {
  V(t.length === 2, "key must have 2 elements");
  var r = e.length, n = "-".concat(t, "-"), a = e.indexOf(n);
  if (a !== -1) {
    for (var i = a + 4, s = i, o = i, u = !1; !u; ) {
      var c = e.indexOf("-", o), d = void 0;
      c === -1 ? d = r - o : d = c - o, d === 2 ? u = !0 : c === -1 ? (s = r, u = !0) : (s = c, o = c + 1);
    }
    return e.slice(i, s);
  }
  if (n = "-".concat(t), a = e.indexOf(n), a !== -1 && a + 3 === r)
    return "";
}
function on(e, t, r, n, a, i) {
  var s = r.localeMatcher, o;
  s === "lookup" ? o = an(Array.from(e), t, i) : o = rn(Array.from(e), t, i);
  for (var u = o.locale, c = { locale: "", dataLocale: u }, d = "-u", h = 0, l = n; h < l.length; h++) {
    var f = l[h];
    V(u in a, "Missing locale data for ".concat(u));
    var v = a[u];
    V(typeof v == "object" && v !== null, "locale data ".concat(f, " must be an object"));
    var m = v[f];
    V(Array.isArray(m), "keyLocaleData for ".concat(f, " must be an array"));
    var y = m[0];
    V(typeof y == "string" || y === null, "value must be string or null but got ".concat(typeof y, " in key ").concat(f));
    var b = "";
    if (o.extension) {
      var T = sn(o.extension, f);
      T !== void 0 && (T !== "" ? ~m.indexOf(T) && (y = T, b = "-".concat(f, "-").concat(y)) : ~T.indexOf("true") && (y = "true", b = "-".concat(f)));
    }
    if (f in r) {
      var w = r[f];
      V(typeof w == "string" || typeof w == "undefined" || w === null, "optionsValue must be String, Undefined or Null"), ~m.indexOf(w) && w !== y && (y = w, b = "");
    }
    c[f] = y, d += b;
  }
  if (d.length > 2) {
    var B = u.indexOf("-x-");
    if (B === -1)
      u = u + d;
    else {
      var P = u.slice(0, B), $ = u.slice(B, u.length);
      u = P + d + $;
    }
    u = Intl.getCanonicalLocales(u)[0];
  }
  return c.locale = u, c;
}
function un(e, t, r, n) {
  return on(t, Xr(e), {
    localeMatcher: (n == null ? void 0 : n.algorithm) || "best fit"
  }, [], {}, function() {
    return r;
  }).locale;
}
function ae(e, t) {
  return Object.keys(e).reduce(function(r, n) {
    return r[n] = _({ timeZone: t }, e[n]), r;
  }, {});
}
function Je(e, t) {
  var r = Object.keys(_(_({}, e), t));
  return r.reduce(function(n, a) {
    return n[a] = _(_({}, e[a] || {}), t[a] || {}), n;
  }, {});
}
function Qe(e, t) {
  if (!t)
    return e;
  var r = It.formats;
  return _(_(_({}, r), e), { date: Je(ae(r.date, t), ae(e.date || {}, t)), time: Je(ae(r.time, t), ae(e.time || {}, t)) });
}
var et = function(e, t, r, n, a) {
  var i = e.locale, s = e.formats, o = e.messages, u = e.defaultLocale, c = e.defaultFormats, d = e.fallbackOnEmptyString, h = e.onError, l = e.timeZone, f = e.defaultRichTextElements;
  r === void 0 && (r = { id: "" });
  var v = r.id, m = r.defaultMessage;
  Wr(!!v, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
  var y = String(v), b = (
    // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    o && Object.prototype.hasOwnProperty.call(o, y) && o[y]
  );
  if (Array.isArray(b) && b.length === 1 && b[0].type === E.literal)
    return b[0].value;
  if (!n && b && typeof b == "string" && !f)
    return b.replace(/'\{(.*?)\}'/gi, "{$1}");
  if (n = _(_({}, f), n || {}), s = Qe(s, l), c = Qe(c, l), !b) {
    if (d === !1 && b === "")
      return b;
    if ((!m || i && i.toLowerCase() !== u.toLowerCase()) && h(new kr(r, i)), m)
      try {
        var T = t.getMessageFormat(m, u, c, a);
        return T.format(n);
      } catch (w) {
        return h(new pe('Error formatting default message for: "'.concat(y, '", rendering default message verbatim'), i, r, w)), typeof m == "string" ? m : y;
      }
    return y;
  }
  try {
    var T = t.getMessageFormat(b, i, s, _({ formatters: t }, a || {}));
    return T.format(n);
  } catch (w) {
    h(new pe('Error formatting message: "'.concat(y, '", using ').concat(m ? "default message" : "id", " as fallback."), i, r, w));
  }
  if (m)
    try {
      var T = t.getMessageFormat(m, u, c, a);
      return T.format(n);
    } catch (w) {
      h(new pe('Error formatting the default message for: "'.concat(y, '", rendering message verbatim'), i, r, w));
    }
  return typeof b == "string" ? b : typeof m == "string" ? m : y;
}, Ct = [
  "formatMatcher",
  "timeZone",
  "hour12",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "hourCycle",
  "dateStyle",
  "timeStyle",
  "calendar",
  // 'dayPeriod',
  "numberingSystem",
  "fractionalSecondDigits"
];
function ce(e, t, r, n) {
  var a = e.locale, i = e.formats, s = e.onError, o = e.timeZone;
  n === void 0 && (n = {});
  var u = n.format, c = _(_({}, o && { timeZone: o }), u && Be(i, t, u, s)), d = j(n, Ct, c);
  return t === "time" && !d.hour && !d.minute && !d.second && !d.timeStyle && !d.dateStyle && (d = _(_({}, d), { hour: "numeric", minute: "numeric" })), r(a, d);
}
function dn(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  var a = r[0], i = r[1], s = i === void 0 ? {} : i, o = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return ce(e, "date", t, s).format(o);
  } catch (u) {
    e.onError(new A("Error formatting date.", e.locale, u));
  }
  return String(o);
}
function cn(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  var a = r[0], i = r[1], s = i === void 0 ? {} : i, o = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return ce(e, "time", t, s).format(o);
  } catch (u) {
    e.onError(new A("Error formatting time.", e.locale, u));
  }
  return String(o);
}
function hn(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  var a = r[0], i = r[1], s = r[2], o = s === void 0 ? {} : s, u = e.timeZone, c = e.locale, d = e.onError, h = j(o, Ct, u ? { timeZone: u } : {});
  try {
    return t(c, h).formatRange(a, i);
  } catch (l) {
    d(new A("Error formatting date time range.", e.locale, l));
  }
  return String(a);
}
function ln(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  var a = r[0], i = r[1], s = i === void 0 ? {} : i, o = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return ce(e, "date", t, s).formatToParts(o);
  } catch (u) {
    e.onError(new A("Error formatting date.", e.locale, u));
  }
  return [];
}
function _n(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  var a = r[0], i = r[1], s = i === void 0 ? {} : i, o = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return ce(e, "time", t, s).formatToParts(o);
  } catch (u) {
    e.onError(new A("Error formatting time.", e.locale, u));
  }
  return [];
}
var fn = [
  "style",
  "type",
  "fallback",
  "languageDisplay"
];
function mn(e, t, r, n) {
  var a = e.locale, i = e.onError, s = Intl.DisplayNames;
  s || i(new R(`Intl.DisplayNames is not available in this environment.
Try polyfilling it using "@formatjs/intl-displaynames"
`, L.MISSING_INTL_API));
  var o = j(n, fn);
  try {
    return t(a, o).of(r);
  } catch (u) {
    i(new A("Error formatting display name.", a, u));
  }
}
var yn = [
  "type",
  "style"
], tt = Date.now();
function gn(e) {
  return "".concat(tt, "_").concat(e, "_").concat(tt);
}
function vn(e, t, r, n) {
  n === void 0 && (n = {});
  var a = Lt(e, t, r, n).reduce(function(i, s) {
    var o = s.value;
    return typeof o != "string" ? i.push(o) : typeof i[i.length - 1] == "string" ? i[i.length - 1] += o : i.push(o), i;
  }, []);
  return a.length === 1 ? a[0] : a.length === 0 ? "" : a;
}
function Lt(e, t, r, n) {
  var a = e.locale, i = e.onError;
  n === void 0 && (n = {});
  var s = Intl.ListFormat;
  s || i(new R(`Intl.ListFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-listformat"
`, L.MISSING_INTL_API));
  var o = j(n, yn);
  try {
    var u = {}, c = r.map(function(d, h) {
      if (typeof d == "object") {
        var l = gn(h);
        return u[l] = d, l;
      }
      return String(d);
    });
    return t(a, o).formatToParts(c).map(function(d) {
      return d.type === "literal" ? d : _(_({}, d), { value: u[d.value] || d.value });
    });
  } catch (d) {
    i(new A("Error formatting list.", a, d));
  }
  return r;
}
var pn = ["type"];
function bn(e, t, r, n) {
  var a = e.locale, i = e.onError;
  n === void 0 && (n = {}), Intl.PluralRules || i(new R(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, L.MISSING_INTL_API));
  var s = j(n, pn);
  try {
    return t(a, s).select(r);
  } catch (o) {
    i(new A("Error formatting plural.", a, o));
  }
  return "other";
}
var En = ["numeric", "style"];
function wn(e, t, r) {
  var n = e.locale, a = e.formats, i = e.onError;
  r === void 0 && (r = {});
  var s = r.format, o = !!s && Be(a, "relative", s, i) || {}, u = j(r, En, o);
  return t(n, u);
}
function Tn(e, t, r, n, a) {
  a === void 0 && (a = {}), n || (n = "second");
  var i = Intl.RelativeTimeFormat;
  i || e.onError(new R(`Intl.RelativeTimeFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-relativetimeformat"
`, L.MISSING_INTL_API));
  try {
    return wn(e, t, a).format(r, n);
  } catch (s) {
    e.onError(new A("Error formatting relative time.", e.locale, s));
  }
  return String(r);
}
var Sn = [
  "style",
  "currency",
  "unit",
  "unitDisplay",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  // ES2020 NumberFormat
  "compactDisplay",
  "currencyDisplay",
  "currencySign",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "numberingSystem",
  // ES2023 NumberFormat
  "trailingZeroDisplay",
  "roundingPriority",
  "roundingIncrement",
  "roundingMode"
];
function Bt(e, t, r) {
  var n = e.locale, a = e.formats, i = e.onError;
  r === void 0 && (r = {});
  var s = r.format, o = s && Be(a, "number", s, i) || {}, u = j(r, Sn, o);
  return t(n, u);
}
function xn(e, t, r, n) {
  n === void 0 && (n = {});
  try {
    return Bt(e, t, n).format(r);
  } catch (a) {
    e.onError(new A("Error formatting number.", e.locale, a));
  }
  return String(r);
}
function Mn(e, t, r, n) {
  n === void 0 && (n = {});
  try {
    return Bt(e, t, n).formatToParts(r);
  } catch (a) {
    e.onError(new A("Error formatting number.", e.locale, a));
  }
  return [];
}
function An(e) {
  var t = e ? e[Object.keys(e)[0]] : void 0;
  return typeof t == "string";
}
function In(e) {
  e.onWarn && e.defaultRichTextElements && An(e.messages || {}) && e.onWarn(`[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. 
Please consider using "@formatjs/cli" to pre-compile your messages for performance.
For more details see https://formatjs.io/docs/getting-started/message-distribution`);
}
function Hn(e, t) {
  var r = Kr(t), n = _(_({}, zr), e), a = n.locale, i = n.defaultLocale, s = n.onError;
  return a ? !Intl.NumberFormat.supportedLocalesOf(a).length && s ? s(new Xe('Missing locale data for locale: "'.concat(a, '" in Intl.NumberFormat. Using default locale: "').concat(i, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details'))) : !Intl.DateTimeFormat.supportedLocalesOf(a).length && s && s(new Xe('Missing locale data for locale: "'.concat(a, '" in Intl.DateTimeFormat. Using default locale: "').concat(i, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details'))) : (s && s(new Vr('"locale" was not configured, using "'.concat(i, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details'))), n.locale = n.defaultLocale || "en"), In(n), _(_({}, n), {
    formatters: r,
    formatNumber: xn.bind(null, n, r.getNumberFormat),
    formatNumberToParts: Mn.bind(null, n, r.getNumberFormat),
    formatRelativeTime: Tn.bind(null, n, r.getRelativeTimeFormat),
    formatDate: dn.bind(null, n, r.getDateTimeFormat),
    formatDateToParts: ln.bind(null, n, r.getDateTimeFormat),
    formatTime: cn.bind(null, n, r.getDateTimeFormat),
    formatDateTimeRange: hn.bind(null, n, r.getDateTimeFormat),
    formatTimeToParts: _n.bind(null, n, r.getDateTimeFormat),
    formatPlural: bn.bind(null, n, r.getPluralRules),
    // @ts-expect-error TODO: will get to this later
    formatMessage: et.bind(null, n, r),
    // @ts-expect-error TODO: will get to this later
    $t: et.bind(null, n, r),
    formatList: vn.bind(null, n, r.getListFormat),
    formatListToParts: Lt.bind(null, n, r.getListFormat),
    formatDisplayName: mn.bind(null, n, r.getDisplayNames)
  });
}
var ie = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Pt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Nn = Y;
Y.flatten = Y;
Y.unflatten = Gt;
function Ot(e) {
  return e && e.constructor && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function Rt(e) {
  return e;
}
function Y(e, t) {
  t = t || {};
  const r = t.delimiter || ".", n = t.maxDepth, a = t.transformKey || Rt, i = {};
  function s(o, u, c) {
    c = c || 1, Object.keys(o).forEach(function(d) {
      const h = o[d], l = t.safe && Array.isArray(h), f = Object.prototype.toString.call(h), v = Ot(h), m = f === "[object Object]" || f === "[object Array]", y = u ? u + r + a(d) : a(d);
      if (!l && !v && m && Object.keys(h).length && (!t.maxDepth || c < n))
        return s(h, y, c + 1);
      i[y] = h;
    });
  }
  return s(e), i;
}
function Gt(e, t) {
  t = t || {};
  const r = t.delimiter || ".", n = t.overwrite || !1, a = t.transformKey || Rt, i = {};
  if (Ot(e) || Object.prototype.toString.call(e) !== "[object Object]")
    return e;
  function o(d) {
    const h = Number(d);
    return isNaN(h) || d.indexOf(".") !== -1 || t.object ? d : h;
  }
  function u(d, h, l) {
    return Object.keys(l).reduce(function(f, v) {
      return f[d + r + v] = l[v], f;
    }, h);
  }
  function c(d) {
    const h = Object.prototype.toString.call(d), l = h === "[object Array]", f = h === "[object Object]";
    if (d) {
      if (l)
        return !d.length;
      if (f)
        return !Object.keys(d).length;
    } else
      return !0;
  }
  return e = Object.keys(e).reduce(function(d, h) {
    const l = Object.prototype.toString.call(e[h]);
    return !(l === "[object Object]" || l === "[object Array]") || c(e[h]) ? (d[h] = e[h], d) : u(
      h,
      d,
      Y(e[h], t)
    );
  }, {}), Object.keys(e).forEach(function(d) {
    const h = d.split(r).map(a);
    let l = o(h.shift()), f = o(h[0]), v = i;
    for (; f !== void 0; ) {
      if (l === "__proto__")
        return;
      const m = Object.prototype.toString.call(v[l]), y = m === "[object Object]" || m === "[object Array]";
      if (!n && !y && typeof v[l] != "undefined")
        return;
      (n && !y || !n && v[l] == null) && (v[l] = typeof f == "number" && !t.object ? [] : {}), v = v[l], h.length > 0 && (l = o(h.shift()), f = o(h[0]));
    }
    v[l] = Gt(e[d], t);
  }), i;
}
const rt = /* @__PURE__ */ Pt(Nn);
var Cn = Array.isArray, Pe = Cn, Ln = typeof ie == "object" && ie && ie.Object === Object && ie, Bn = Ln, Pn = Bn, On = typeof self == "object" && self && self.Object === Object && self, Rn = Pn || On || Function("return this")(), Oe = Rn, Gn = Oe, Dn = Gn.Symbol, Re = Dn, nt = Re, Dt = Object.prototype, Fn = Dt.hasOwnProperty, Un = Dt.toString, X = nt ? nt.toStringTag : void 0;
function jn(e) {
  var t = Fn.call(e, X), r = e[X];
  try {
    e[X] = void 0;
    var n = !0;
  } catch (i) {
  }
  var a = Un.call(e);
  return n && (t ? e[X] = r : delete e[X]), a;
}
var $n = jn, Vn = Object.prototype, kn = Vn.toString;
function Zn(e) {
  return kn.call(e);
}
var qn = Zn, at = Re, zn = $n, Kn = qn, Wn = "[object Null]", Xn = "[object Undefined]", it = at ? at.toStringTag : void 0;
function Yn(e) {
  return e == null ? e === void 0 ? Xn : Wn : it && it in Object(e) ? zn(e) : Kn(e);
}
var Ft = Yn;
function Jn(e) {
  return e != null && typeof e == "object";
}
var Qn = Jn, ea = Ft, ta = Qn, ra = "[object Symbol]";
function na(e) {
  return typeof e == "symbol" || ta(e) && ea(e) == ra;
}
var Ge = na, aa = Pe, ia = Ge, sa = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, oa = /^\w*$/;
function ua(e, t) {
  if (aa(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || ia(e) ? !0 : oa.test(e) || !sa.test(e) || t != null && e in Object(t);
}
var da = ua;
function ca(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Ut = ca, ha = Ft, la = Ut, _a = "[object AsyncFunction]", fa = "[object Function]", ma = "[object GeneratorFunction]", ya = "[object Proxy]";
function ga(e) {
  if (!la(e))
    return !1;
  var t = ha(e);
  return t == fa || t == ma || t == _a || t == ya;
}
var va = ga, pa = Oe, ba = pa["__core-js_shared__"], Ea = ba, Te = Ea, st = function() {
  var e = /[^.]+$/.exec(Te && Te.keys && Te.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function wa(e) {
  return !!st && st in e;
}
var Ta = wa, Sa = Function.prototype, xa = Sa.toString;
function Ma(e) {
  if (e != null) {
    try {
      return xa.call(e);
    } catch (t) {
    }
    try {
      return e + "";
    } catch (t) {
    }
  }
  return "";
}
var Aa = Ma, Ia = va, Ha = Ta, Na = Ut, Ca = Aa, La = /[\\^$.*+?()[\]{}|]/g, Ba = /^\[object .+?Constructor\]$/, Pa = Function.prototype, Oa = Object.prototype, Ra = Pa.toString, Ga = Oa.hasOwnProperty, Da = RegExp(
  "^" + Ra.call(Ga).replace(La, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Fa(e) {
  if (!Na(e) || Ha(e))
    return !1;
  var t = Ia(e) ? Da : Ba;
  return t.test(Ca(e));
}
var Ua = Fa;
function ja(e, t) {
  return e == null ? void 0 : e[t];
}
var $a = ja, Va = Ua, ka = $a;
function Za(e, t) {
  var r = ka(e, t);
  return Va(r) ? r : void 0;
}
var jt = Za, qa = jt, za = qa(Object, "create"), he = za, ot = he;
function Ka() {
  this.__data__ = ot ? ot(null) : {}, this.size = 0;
}
var Wa = Ka;
function Xa(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Ya = Xa, Ja = he, Qa = "__lodash_hash_undefined__", ei = Object.prototype, ti = ei.hasOwnProperty;
function ri(e) {
  var t = this.__data__;
  if (Ja) {
    var r = t[e];
    return r === Qa ? void 0 : r;
  }
  return ti.call(t, e) ? t[e] : void 0;
}
var ni = ri, ai = he, ii = Object.prototype, si = ii.hasOwnProperty;
function oi(e) {
  var t = this.__data__;
  return ai ? t[e] !== void 0 : si.call(t, e);
}
var ui = oi, di = he, ci = "__lodash_hash_undefined__";
function hi(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = di && t === void 0 ? ci : t, this;
}
var li = hi, _i = Wa, fi = Ya, mi = ni, yi = ui, gi = li;
function z(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
z.prototype.clear = _i;
z.prototype.delete = fi;
z.prototype.get = mi;
z.prototype.has = yi;
z.prototype.set = gi;
var vi = z;
function pi() {
  this.__data__ = [], this.size = 0;
}
var bi = pi;
function Ei(e, t) {
  return e === t || e !== e && t !== t;
}
var wi = Ei, Ti = wi;
function Si(e, t) {
  for (var r = e.length; r--; )
    if (Ti(e[r][0], t))
      return r;
  return -1;
}
var le = Si, xi = le, Mi = Array.prototype, Ai = Mi.splice;
function Ii(e) {
  var t = this.__data__, r = xi(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : Ai.call(t, r, 1), --this.size, !0;
}
var Hi = Ii, Ni = le;
function Ci(e) {
  var t = this.__data__, r = Ni(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var Li = Ci, Bi = le;
function Pi(e) {
  return Bi(this.__data__, e) > -1;
}
var Oi = Pi, Ri = le;
function Gi(e, t) {
  var r = this.__data__, n = Ri(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var Di = Gi, Fi = bi, Ui = Hi, ji = Li, $i = Oi, Vi = Di;
function K(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
K.prototype.clear = Fi;
K.prototype.delete = Ui;
K.prototype.get = ji;
K.prototype.has = $i;
K.prototype.set = Vi;
var ki = K, Zi = jt, qi = Oe, zi = Zi(qi, "Map"), Ki = zi, ut = vi, Wi = ki, Xi = Ki;
function Yi() {
  this.size = 0, this.__data__ = {
    hash: new ut(),
    map: new (Xi || Wi)(),
    string: new ut()
  };
}
var Ji = Yi;
function Qi(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var es = Qi, ts = es;
function rs(e, t) {
  var r = e.__data__;
  return ts(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var _e = rs, ns = _e;
function as(e) {
  var t = ns(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var is = as, ss = _e;
function os(e) {
  return ss(this, e).get(e);
}
var us = os, ds = _e;
function cs(e) {
  return ds(this, e).has(e);
}
var hs = cs, ls = _e;
function _s(e, t) {
  var r = ls(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var fs = _s, ms = Ji, ys = is, gs = us, vs = hs, ps = fs;
function W(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
W.prototype.clear = ms;
W.prototype.delete = ys;
W.prototype.get = gs;
W.prototype.has = vs;
W.prototype.set = ps;
var bs = W, $t = bs, Es = "Expected a function";
function De(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Es);
  var r = function() {
    var n = arguments, a = t ? t.apply(this, n) : n[0], i = r.cache;
    if (i.has(a))
      return i.get(a);
    var s = e.apply(this, n);
    return r.cache = i.set(a, s) || i, s;
  };
  return r.cache = new (De.Cache || $t)(), r;
}
De.Cache = $t;
var ws = De, Ts = ws, Ss = 500;
function xs(e) {
  var t = Ts(e, function(n) {
    return r.size === Ss && r.clear(), n;
  }), r = t.cache;
  return t;
}
var Ms = xs, As = Ms, Is = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Hs = /\\(\\)?/g, Ns = As(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Is, function(r, n, a, i) {
    t.push(a ? i.replace(Hs, "$1") : n || r);
  }), t;
}), Cs = Ns;
function Ls(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = Array(n); ++r < n; )
    a[r] = t(e[r], r, e);
  return a;
}
var Bs = Ls, dt = Re, Ps = Bs, Os = Pe, Rs = Ge, Gs = 1 / 0, ct = dt ? dt.prototype : void 0, ht = ct ? ct.toString : void 0;
function Vt(e) {
  if (typeof e == "string")
    return e;
  if (Os(e))
    return Ps(e, Vt) + "";
  if (Rs(e))
    return ht ? ht.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -Gs ? "-0" : t;
}
var Ds = Vt, Fs = Ds;
function Us(e) {
  return e == null ? "" : Fs(e);
}
var js = Us, $s = Pe, Vs = da, ks = Cs, Zs = js;
function qs(e, t) {
  return $s(e) ? e : Vs(e, t) ? [e] : ks(Zs(e));
}
var zs = qs, Ks = Ge, Ws = 1 / 0;
function Xs(e) {
  if (typeof e == "string" || Ks(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -Ws ? "-0" : t;
}
var Ys = Xs, Js = zs, Qs = Ys;
function eo(e, t) {
  t = Js(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[Qs(t[r++])];
  return r && r == n ? e : void 0;
}
var to = eo, ro = to;
function no(e, t, r) {
  var n = e == null ? void 0 : ro(e, t);
  return n === void 0 ? r : n;
}
var ao = no;
const io = /* @__PURE__ */ Pt(ao), so = {
  a: "ȧ",
  A: "Ȧ",
  b: "ƀ",
  B: "Ɓ",
  c: "ƈ",
  C: "Ƈ",
  d: "ḓ",
  D: "Ḓ",
  e: "ḗ",
  E: "Ḗ",
  f: "ƒ",
  F: "Ƒ",
  g: "ɠ",
  G: "Ɠ",
  h: "ħ",
  H: "Ħ",
  i: "ī",
  I: "Ī",
  j: "ĵ",
  J: "Ĵ",
  k: "ķ",
  K: "Ķ",
  l: "ŀ",
  L: "Ŀ",
  m: "ḿ",
  M: "Ḿ",
  n: "ƞ",
  N: "Ƞ",
  o: "ǿ",
  O: "Ǿ",
  p: "ƥ",
  P: "Ƥ",
  q: "ɋ",
  Q: "Ɋ",
  r: "ř",
  R: "Ř",
  s: "ş",
  S: "Ş",
  t: "ŧ",
  T: "Ŧ",
  v: "ṽ",
  V: "Ṽ",
  u: "ŭ",
  U: "Ŭ",
  w: "ẇ",
  W: "Ẇ",
  x: "ẋ",
  X: "Ẋ",
  y: "ẏ",
  Y: "Ẏ",
  z: "ẑ",
  Z: "Ẑ"
}, oo = Ht(), uo = (e) => {
  process.env.NODE_ENV !== "production" && console.error(e);
};
var F, k, O, Z, J, Q, oe, kt, ue, Zt, de, qt;
class co {
  constructor({
    locales: t,
    defaultLocale: r,
    userPreferredLocales: n,
    pseudoMode: a = !1,
    pseudoPercentage: i = 1.3
  }) {
    H(this, oe);
    H(this, ue);
    H(this, de);
    H(this, F, void 0);
    H(this, k, void 0);
    H(this, O, void 0);
    H(this, Z, void 0);
    H(this, J, void 0);
    H(this, Q, void 0);
    if (t.some((s) => !("code" in s) || !("messages" in s)))
      throw new Error(
        "Each locale object should provide values for 'code' and 'messages'"
      );
    if (!t.some((s) => s.code === r))
      throw new Error(
        `Default locale ${r} does not match any provided locale`
      );
    G(this, F, t), G(this, k, te(this, oe, kt).call(this, x(this, F))), G(this, O, r), G(this, Z, n || []), G(this, J, a), G(this, Q, i);
  }
  createIntlWithLocale(t, r = uo) {
    let n = te(this, ue, Zt).call(this, t, r);
    const a = x(this, k)[n], i = x(this, k)[x(this, O)];
    return te(this, de, qt).call(this, {
      locale: n,
      messages: a,
      defaultLocale: x(this, O),
      defaultMessages: i,
      errorHandler: r
    });
  }
  getAvailableLocales() {
    return x(this, F).map((t) => t.code);
  }
}
F = new WeakMap(), k = new WeakMap(), O = new WeakMap(), Z = new WeakMap(), J = new WeakMap(), Q = new WeakMap(), oe = new WeakSet(), kt = function(t) {
  return t.reduce((r, { code: n, messages: a }) => me(fe({}, r), {
    [n]: a
  }), {});
}, ue = new WeakSet(), Zt = function(t, r) {
  const n = t ? [t, ...x(this, Z)] : x(this, Z);
  let a;
  try {
    a = un(
      n,
      x(this, F).map((i) => i.code),
      x(this, O),
      { algorithm: "lookup" }
    );
  } catch (i) {
    a = x(this, O), r(i);
  }
  return a;
}, de = new WeakSet(), qt = function({
  locale: t,
  messages: r,
  defaultLocale: n,
  defaultMessages: a,
  errorHandler: i
}) {
  const s = rt(r), o = rt(a), u = Hn(
    {
      locale: t,
      messages: s,
      defaultLocale: n,
      onError: i
    },
    oo
  ), c = (d, h) => {
    const l = io(o, d, ""), f = u.formatMessage({ id: d, defaultMessage: l }, h, {
      ignoreTag: !0
    });
    if (f && x(this, J)) {
      const v = Math.floor(f.length * x(this, Q));
      return f.split("").reduce((m, y, b) => {
        const T = so[y] || y;
        return m.length + (f.length - b) < v ? `${m}${T}${T}` : m.length === v ? m : `${m}${T}`;
      }, "");
    }
    return f;
  };
  return u.$t = c, u.$d = u.formatDate, u;
};
const lo = {
  install: (e, { defaultLocale: t, locales: r, pseudoMode: n, pseudoPercentage: a }) => {
    const i = navigator.languages || [], s = new co({
      locales: r,
      defaultLocale: t,
      userPreferredLocales: i,
      pseudoMode: n,
      pseudoPercentage: a
    });
    e.config.globalProperties.$intlManager = s;
    const o = (u, c) => {
      const d = s.createIntlWithLocale(u, c);
      e.config.globalProperties.$intl = me(fe({}, d), { $setLocale: o }), e.config.globalProperties.$t = d.$t, e.config.globalProperties.$d = d.$d;
    };
    o(null);
  }
};
export {
  co as IntlManager,
  lo as VueIntl
};
